import le, { createContext as be, useCallback as Et, useContext as Re, useState as rr, useEffect as Gt, useRef as Ne } from "react";
import ce from "redaxios";
import { Transaction as Ae } from "@ethereumjs/tx";
var Pt = /* @__PURE__ */ ((i) => (i.SD = "sd", i.ETHX = "ethx", i.BNBX = "bnbx", i.MATICX = "maticx", i.SFTMX = "sftmx", i))(Pt || {}), Te = /* @__PURE__ */ ((i) => (i.TOKEN = "token", i.TOKENX = "tokenx", i))(Te || {}), Se = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Ie(i) {
  var n = i.default;
  if (typeof n == "function") {
    var u = function() {
      return n.apply(this, arguments);
    };
    u.prototype = n.prototype;
  } else
    u = {};
  return Object.defineProperty(u, "__esModule", { value: !0 }), Object.keys(i).forEach(function(d) {
    var g = Object.getOwnPropertyDescriptor(i, d);
    Object.defineProperty(u, d, g.get ? g : {
      enumerable: !0,
      get: function() {
        return i[d];
      }
    });
  }), u;
}
var de = { exports: {} };
const Oe = {}, Pe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Oe
}, Symbol.toStringTag, { value: "Module" })), Ue = /* @__PURE__ */ Ie(Pe);
(function(i) {
  (function(n, u) {
    function d(m, t) {
      if (!m)
        throw new Error(t || "Assertion failed");
    }
    function g(m, t) {
      m.super_ = t;
      var e = function() {
      };
      e.prototype = t.prototype, m.prototype = new e(), m.prototype.constructor = m;
    }
    function l(m, t, e) {
      if (l.isBN(m))
        return m;
      this.negative = 0, this.words = null, this.length = 0, this.red = null, m !== null && ((t === "le" || t === "be") && (e = t, t = 10), this._init(m || 0, t || 10, e || "be"));
    }
    typeof n == "object" ? n.exports = l : u.BN = l, l.BN = l, l.wordSize = 26;
    var y;
    try {
      typeof window < "u" && typeof window.Buffer < "u" ? y = window.Buffer : y = Ue.Buffer;
    } catch {
    }
    l.isBN = function(t) {
      return t instanceof l ? !0 : t !== null && typeof t == "object" && t.constructor.wordSize === l.wordSize && Array.isArray(t.words);
    }, l.max = function(t, e) {
      return t.cmp(e) > 0 ? t : e;
    }, l.min = function(t, e) {
      return t.cmp(e) < 0 ? t : e;
    }, l.prototype._init = function(t, e, o) {
      if (typeof t == "number")
        return this._initNumber(t, e, o);
      if (typeof t == "object")
        return this._initArray(t, e, o);
      e === "hex" && (e = 16), d(e === (e | 0) && e >= 2 && e <= 36), t = t.toString().replace(/\s+/g, "");
      var f = 0;
      t[0] === "-" && (f++, this.negative = 1), f < t.length && (e === 16 ? this._parseHex(t, f, o) : (this._parseBase(t, e, f), o === "le" && this._initArray(this.toArray(), e, o)));
    }, l.prototype._initNumber = function(t, e, o) {
      t < 0 && (this.negative = 1, t = -t), t < 67108864 ? (this.words = [t & 67108863], this.length = 1) : t < 4503599627370496 ? (this.words = [
        t & 67108863,
        t / 67108864 & 67108863
      ], this.length = 2) : (d(t < 9007199254740992), this.words = [
        t & 67108863,
        t / 67108864 & 67108863,
        1
      ], this.length = 3), o === "le" && this._initArray(this.toArray(), e, o);
    }, l.prototype._initArray = function(t, e, o) {
      if (d(typeof t.length == "number"), t.length <= 0)
        return this.words = [0], this.length = 1, this;
      this.length = Math.ceil(t.length / 3), this.words = new Array(this.length);
      for (var f = 0; f < this.length; f++)
        this.words[f] = 0;
      var c, p, v = 0;
      if (o === "be")
        for (f = t.length - 1, c = 0; f >= 0; f -= 3)
          p = t[f] | t[f - 1] << 8 | t[f - 2] << 16, this.words[c] |= p << v & 67108863, this.words[c + 1] = p >>> 26 - v & 67108863, v += 24, v >= 26 && (v -= 26, c++);
      else if (o === "le")
        for (f = 0, c = 0; f < t.length; f += 3)
          p = t[f] | t[f + 1] << 8 | t[f + 2] << 16, this.words[c] |= p << v & 67108863, this.words[c + 1] = p >>> 26 - v & 67108863, v += 24, v >= 26 && (v -= 26, c++);
      return this._strip();
    };
    function T(m, t) {
      var e = m.charCodeAt(t);
      if (e >= 48 && e <= 57)
        return e - 48;
      if (e >= 65 && e <= 70)
        return e - 55;
      if (e >= 97 && e <= 102)
        return e - 87;
      d(!1, "Invalid character in " + m);
    }
    function _(m, t, e) {
      var o = T(m, e);
      return e - 1 >= t && (o |= T(m, e - 1) << 4), o;
    }
    l.prototype._parseHex = function(t, e, o) {
      this.length = Math.ceil((t.length - e) / 6), this.words = new Array(this.length);
      for (var f = 0; f < this.length; f++)
        this.words[f] = 0;
      var c = 0, p = 0, v;
      if (o === "be")
        for (f = t.length - 1; f >= e; f -= 2)
          v = _(t, e, f) << c, this.words[p] |= v & 67108863, c >= 18 ? (c -= 18, p += 1, this.words[p] |= v >>> 26) : c += 8;
      else {
        var s = t.length - e;
        for (f = s % 2 === 0 ? e + 1 : e; f < t.length; f += 2)
          v = _(t, e, f) << c, this.words[p] |= v & 67108863, c >= 18 ? (c -= 18, p += 1, this.words[p] |= v >>> 26) : c += 8;
      }
      this._strip();
    };
    function U(m, t, e, o) {
      for (var f = 0, c = 0, p = Math.min(m.length, e), v = t; v < p; v++) {
        var s = m.charCodeAt(v) - 48;
        f *= o, s >= 49 ? c = s - 49 + 10 : s >= 17 ? c = s - 17 + 10 : c = s, d(s >= 0 && c < o, "Invalid character"), f += c;
      }
      return f;
    }
    l.prototype._parseBase = function(t, e, o) {
      this.words = [0], this.length = 1;
      for (var f = 0, c = 1; c <= 67108863; c *= e)
        f++;
      f--, c = c / e | 0;
      for (var p = t.length - o, v = p % f, s = Math.min(p, p - v) + o, r = 0, a = o; a < s; a += f)
        r = U(t, a, a + f, e), this.imuln(c), this.words[0] + r < 67108864 ? this.words[0] += r : this._iaddn(r);
      if (v !== 0) {
        var A = 1;
        for (r = U(t, a, t.length, e), a = 0; a < v; a++)
          A *= e;
        this.imuln(A), this.words[0] + r < 67108864 ? this.words[0] += r : this._iaddn(r);
      }
      this._strip();
    }, l.prototype.copy = function(t) {
      t.words = new Array(this.length);
      for (var e = 0; e < this.length; e++)
        t.words[e] = this.words[e];
      t.length = this.length, t.negative = this.negative, t.red = this.red;
    };
    function C(m, t) {
      m.words = t.words, m.length = t.length, m.negative = t.negative, m.red = t.red;
    }
    if (l.prototype._move = function(t) {
      C(t, this);
    }, l.prototype.clone = function() {
      var t = new l(null);
      return this.copy(t), t;
    }, l.prototype._expand = function(t) {
      for (; this.length < t; )
        this.words[this.length++] = 0;
      return this;
    }, l.prototype._strip = function() {
      for (; this.length > 1 && this.words[this.length - 1] === 0; )
        this.length--;
      return this._normSign();
    }, l.prototype._normSign = function() {
      return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
    }, typeof Symbol < "u" && typeof Symbol.for == "function")
      try {
        l.prototype[Symbol.for("nodejs.util.inspect.custom")] = B;
      } catch {
        l.prototype.inspect = B;
      }
    else
      l.prototype.inspect = B;
    function B() {
      return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    var yt = [
      "",
      "0",
      "00",
      "000",
      "0000",
      "00000",
      "000000",
      "0000000",
      "00000000",
      "000000000",
      "0000000000",
      "00000000000",
      "000000000000",
      "0000000000000",
      "00000000000000",
      "000000000000000",
      "0000000000000000",
      "00000000000000000",
      "000000000000000000",
      "0000000000000000000",
      "00000000000000000000",
      "000000000000000000000",
      "0000000000000000000000",
      "00000000000000000000000",
      "000000000000000000000000",
      "0000000000000000000000000"
    ], L = [
      0,
      0,
      25,
      16,
      12,
      11,
      10,
      9,
      8,
      8,
      7,
      7,
      7,
      7,
      6,
      6,
      6,
      6,
      6,
      6,
      6,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5,
      5
    ], Lt = [
      0,
      0,
      33554432,
      43046721,
      16777216,
      48828125,
      60466176,
      40353607,
      16777216,
      43046721,
      1e7,
      19487171,
      35831808,
      62748517,
      7529536,
      11390625,
      16777216,
      24137569,
      34012224,
      47045881,
      64e6,
      4084101,
      5153632,
      6436343,
      7962624,
      9765625,
      11881376,
      14348907,
      17210368,
      20511149,
      243e5,
      28629151,
      33554432,
      39135393,
      45435424,
      52521875,
      60466176
    ];
    l.prototype.toString = function(t, e) {
      t = t || 10, e = e | 0 || 1;
      var o;
      if (t === 16 || t === "hex") {
        o = "";
        for (var f = 0, c = 0, p = 0; p < this.length; p++) {
          var v = this.words[p], s = ((v << f | c) & 16777215).toString(16);
          c = v >>> 24 - f & 16777215, f += 2, f >= 26 && (f -= 26, p--), c !== 0 || p !== this.length - 1 ? o = yt[6 - s.length] + s + o : o = s + o;
        }
        for (c !== 0 && (o = c.toString(16) + o); o.length % e !== 0; )
          o = "0" + o;
        return this.negative !== 0 && (o = "-" + o), o;
      }
      if (t === (t | 0) && t >= 2 && t <= 36) {
        var r = L[t], a = Lt[t];
        o = "";
        var A = this.clone();
        for (A.negative = 0; !A.isZero(); ) {
          var b = A.modrn(a).toString(t);
          A = A.idivn(a), A.isZero() ? o = b + o : o = yt[r - b.length] + b + o;
        }
        for (this.isZero() && (o = "0" + o); o.length % e !== 0; )
          o = "0" + o;
        return this.negative !== 0 && (o = "-" + o), o;
      }
      d(!1, "Base should be between 2 and 36");
    }, l.prototype.toNumber = function() {
      var t = this.words[0];
      return this.length === 2 ? t += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? t += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && d(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -t : t;
    }, l.prototype.toJSON = function() {
      return this.toString(16, 2);
    }, y && (l.prototype.toBuffer = function(t, e) {
      return this.toArrayLike(y, t, e);
    }), l.prototype.toArray = function(t, e) {
      return this.toArrayLike(Array, t, e);
    };
    var Vt = function(t, e) {
      return t.allocUnsafe ? t.allocUnsafe(e) : new t(e);
    };
    l.prototype.toArrayLike = function(t, e, o) {
      this._strip();
      var f = this.byteLength(), c = o || Math.max(1, f);
      d(f <= c, "byte array longer than desired length"), d(c > 0, "Requested array length <= 0");
      var p = Vt(t, c), v = e === "le" ? "LE" : "BE";
      return this["_toArrayLike" + v](p, f), p;
    }, l.prototype._toArrayLikeLE = function(t, e) {
      for (var o = 0, f = 0, c = 0, p = 0; c < this.length; c++) {
        var v = this.words[c] << p | f;
        t[o++] = v & 255, o < t.length && (t[o++] = v >> 8 & 255), o < t.length && (t[o++] = v >> 16 & 255), p === 6 ? (o < t.length && (t[o++] = v >> 24 & 255), f = 0, p = 0) : (f = v >>> 24, p += 2);
      }
      if (o < t.length)
        for (t[o++] = f; o < t.length; )
          t[o++] = 0;
    }, l.prototype._toArrayLikeBE = function(t, e) {
      for (var o = t.length - 1, f = 0, c = 0, p = 0; c < this.length; c++) {
        var v = this.words[c] << p | f;
        t[o--] = v & 255, o >= 0 && (t[o--] = v >> 8 & 255), o >= 0 && (t[o--] = v >> 16 & 255), p === 6 ? (o >= 0 && (t[o--] = v >> 24 & 255), f = 0, p = 0) : (f = v >>> 24, p += 2);
      }
      if (o >= 0)
        for (t[o--] = f; o >= 0; )
          t[o--] = 0;
    }, Math.clz32 ? l.prototype._countBits = function(t) {
      return 32 - Math.clz32(t);
    } : l.prototype._countBits = function(t) {
      var e = t, o = 0;
      return e >= 4096 && (o += 13, e >>>= 13), e >= 64 && (o += 7, e >>>= 7), e >= 8 && (o += 4, e >>>= 4), e >= 2 && (o += 2, e >>>= 2), o + e;
    }, l.prototype._zeroBits = function(t) {
      if (t === 0)
        return 26;
      var e = t, o = 0;
      return (e & 8191) === 0 && (o += 13, e >>>= 13), (e & 127) === 0 && (o += 7, e >>>= 7), (e & 15) === 0 && (o += 4, e >>>= 4), (e & 3) === 0 && (o += 2, e >>>= 2), (e & 1) === 0 && o++, o;
    }, l.prototype.bitLength = function() {
      var t = this.words[this.length - 1], e = this._countBits(t);
      return (this.length - 1) * 26 + e;
    };
    function er(m) {
      for (var t = new Array(m.bitLength()), e = 0; e < t.length; e++) {
        var o = e / 26 | 0, f = e % 26;
        t[e] = m.words[o] >>> f & 1;
      }
      return t;
    }
    l.prototype.zeroBits = function() {
      if (this.isZero())
        return 0;
      for (var t = 0, e = 0; e < this.length; e++) {
        var o = this._zeroBits(this.words[e]);
        if (t += o, o !== 26)
          break;
      }
      return t;
    }, l.prototype.byteLength = function() {
      return Math.ceil(this.bitLength() / 8);
    }, l.prototype.toTwos = function(t) {
      return this.negative !== 0 ? this.abs().inotn(t).iaddn(1) : this.clone();
    }, l.prototype.fromTwos = function(t) {
      return this.testn(t - 1) ? this.notn(t).iaddn(1).ineg() : this.clone();
    }, l.prototype.isNeg = function() {
      return this.negative !== 0;
    }, l.prototype.neg = function() {
      return this.clone().ineg();
    }, l.prototype.ineg = function() {
      return this.isZero() || (this.negative ^= 1), this;
    }, l.prototype.iuor = function(t) {
      for (; this.length < t.length; )
        this.words[this.length++] = 0;
      for (var e = 0; e < t.length; e++)
        this.words[e] = this.words[e] | t.words[e];
      return this._strip();
    }, l.prototype.ior = function(t) {
      return d((this.negative | t.negative) === 0), this.iuor(t);
    }, l.prototype.or = function(t) {
      return this.length > t.length ? this.clone().ior(t) : t.clone().ior(this);
    }, l.prototype.uor = function(t) {
      return this.length > t.length ? this.clone().iuor(t) : t.clone().iuor(this);
    }, l.prototype.iuand = function(t) {
      var e;
      this.length > t.length ? e = t : e = this;
      for (var o = 0; o < e.length; o++)
        this.words[o] = this.words[o] & t.words[o];
      return this.length = e.length, this._strip();
    }, l.prototype.iand = function(t) {
      return d((this.negative | t.negative) === 0), this.iuand(t);
    }, l.prototype.and = function(t) {
      return this.length > t.length ? this.clone().iand(t) : t.clone().iand(this);
    }, l.prototype.uand = function(t) {
      return this.length > t.length ? this.clone().iuand(t) : t.clone().iuand(this);
    }, l.prototype.iuxor = function(t) {
      var e, o;
      this.length > t.length ? (e = this, o = t) : (e = t, o = this);
      for (var f = 0; f < o.length; f++)
        this.words[f] = e.words[f] ^ o.words[f];
      if (this !== e)
        for (; f < e.length; f++)
          this.words[f] = e.words[f];
      return this.length = e.length, this._strip();
    }, l.prototype.ixor = function(t) {
      return d((this.negative | t.negative) === 0), this.iuxor(t);
    }, l.prototype.xor = function(t) {
      return this.length > t.length ? this.clone().ixor(t) : t.clone().ixor(this);
    }, l.prototype.uxor = function(t) {
      return this.length > t.length ? this.clone().iuxor(t) : t.clone().iuxor(this);
    }, l.prototype.inotn = function(t) {
      d(typeof t == "number" && t >= 0);
      var e = Math.ceil(t / 26) | 0, o = t % 26;
      this._expand(e), o > 0 && e--;
      for (var f = 0; f < e; f++)
        this.words[f] = ~this.words[f] & 67108863;
      return o > 0 && (this.words[f] = ~this.words[f] & 67108863 >> 26 - o), this._strip();
    }, l.prototype.notn = function(t) {
      return this.clone().inotn(t);
    }, l.prototype.setn = function(t, e) {
      d(typeof t == "number" && t >= 0);
      var o = t / 26 | 0, f = t % 26;
      return this._expand(o + 1), e ? this.words[o] = this.words[o] | 1 << f : this.words[o] = this.words[o] & ~(1 << f), this._strip();
    }, l.prototype.iadd = function(t) {
      var e;
      if (this.negative !== 0 && t.negative === 0)
        return this.negative = 0, e = this.isub(t), this.negative ^= 1, this._normSign();
      if (this.negative === 0 && t.negative !== 0)
        return t.negative = 0, e = this.isub(t), t.negative = 1, e._normSign();
      var o, f;
      this.length > t.length ? (o = this, f = t) : (o = t, f = this);
      for (var c = 0, p = 0; p < f.length; p++)
        e = (o.words[p] | 0) + (f.words[p] | 0) + c, this.words[p] = e & 67108863, c = e >>> 26;
      for (; c !== 0 && p < o.length; p++)
        e = (o.words[p] | 0) + c, this.words[p] = e & 67108863, c = e >>> 26;
      if (this.length = o.length, c !== 0)
        this.words[this.length] = c, this.length++;
      else if (o !== this)
        for (; p < o.length; p++)
          this.words[p] = o.words[p];
      return this;
    }, l.prototype.add = function(t) {
      var e;
      return t.negative !== 0 && this.negative === 0 ? (t.negative = 0, e = this.sub(t), t.negative ^= 1, e) : t.negative === 0 && this.negative !== 0 ? (this.negative = 0, e = t.sub(this), this.negative = 1, e) : this.length > t.length ? this.clone().iadd(t) : t.clone().iadd(this);
    }, l.prototype.isub = function(t) {
      if (t.negative !== 0) {
        t.negative = 0;
        var e = this.iadd(t);
        return t.negative = 1, e._normSign();
      } else if (this.negative !== 0)
        return this.negative = 0, this.iadd(t), this.negative = 1, this._normSign();
      var o = this.cmp(t);
      if (o === 0)
        return this.negative = 0, this.length = 1, this.words[0] = 0, this;
      var f, c;
      o > 0 ? (f = this, c = t) : (f = t, c = this);
      for (var p = 0, v = 0; v < c.length; v++)
        e = (f.words[v] | 0) - (c.words[v] | 0) + p, p = e >> 26, this.words[v] = e & 67108863;
      for (; p !== 0 && v < f.length; v++)
        e = (f.words[v] | 0) + p, p = e >> 26, this.words[v] = e & 67108863;
      if (p === 0 && v < f.length && f !== this)
        for (; v < f.length; v++)
          this.words[v] = f.words[v];
      return this.length = Math.max(this.length, v), f !== this && (this.negative = 1), this._strip();
    }, l.prototype.sub = function(t) {
      return this.clone().isub(t);
    };
    function Ft(m, t, e) {
      e.negative = t.negative ^ m.negative;
      var o = m.length + t.length | 0;
      e.length = o, o = o - 1 | 0;
      var f = m.words[0] | 0, c = t.words[0] | 0, p = f * c, v = p & 67108863, s = p / 67108864 | 0;
      e.words[0] = v;
      for (var r = 1; r < o; r++) {
        for (var a = s >>> 26, A = s & 67108863, b = Math.min(r, t.length - 1), R = Math.max(0, r - m.length + 1); R <= b; R++) {
          var xt = r - R | 0;
          f = m.words[xt] | 0, c = t.words[R] | 0, p = f * c + A, a += p / 67108864 | 0, A = p & 67108863;
        }
        e.words[r] = A | 0, s = a | 0;
      }
      return s !== 0 ? e.words[r] = s | 0 : e.length--, e._strip();
    }
    var bt = function(t, e, o) {
      var f = t.words, c = e.words, p = o.words, v = 0, s, r, a, A = f[0] | 0, b = A & 8191, R = A >>> 13, xt = f[1] | 0, k = xt & 8191, D = xt >>> 13, jt = f[2] | 0, rt = jt & 8191, H = jt >>> 13, xr = f[3] | 0, et = xr & 8191, q = xr >>> 13, zt = f[4] | 0, Z = zt & 8191, X = zt >>> 13, Ht = f[5] | 0, it = Ht & 8191, nt = Ht >>> 13, Xt = f[6] | 0, ot = Xt & 8191, st = Xt >>> 13, sr = f[7] | 0, K = sr & 8191, $ = sr >>> 13, Er = f[8] | 0, Y = Er & 8191, J = Er >>> 13, Kt = f[9] | 0, ft = Kt & 8191, at = Kt >>> 13, _r = c[0] | 0, ht = _r & 8191, ut = _r >>> 13, br = c[1] | 0, lt = br & 8191, G = br >>> 13, fr = c[2] | 0, F = fr & 8191, V = fr >>> 13, Yt = c[3] | 0, Q = Yt & 8191, ct = Yt >>> 13, ar = c[4] | 0, dt = ar & 8191, tt = ar >>> 13, hr = c[5] | 0, mt = hr & 8191, pt = hr >>> 13, ur = c[6] | 0, vt = ur & 8191, gt = ur >>> 13, Rr = c[7] | 0, wt = Rr & 8191, h = Rr >>> 13, w = c[8] | 0, M = w & 8191, x = w >>> 13, O = c[9] | 0, N = O & 8191, E = O >>> 13;
      o.negative = t.negative ^ e.negative, o.length = 19, s = Math.imul(b, ht), r = Math.imul(b, ut), r = r + Math.imul(R, ht) | 0, a = Math.imul(R, ut);
      var S = (v + s | 0) + ((r & 8191) << 13) | 0;
      v = (a + (r >>> 13) | 0) + (S >>> 26) | 0, S &= 67108863, s = Math.imul(k, ht), r = Math.imul(k, ut), r = r + Math.imul(D, ht) | 0, a = Math.imul(D, ut), s = s + Math.imul(b, lt) | 0, r = r + Math.imul(b, G) | 0, r = r + Math.imul(R, lt) | 0, a = a + Math.imul(R, G) | 0;
      var _t = (v + s | 0) + ((r & 8191) << 13) | 0;
      v = (a + (r >>> 13) | 0) + (_t >>> 26) | 0, _t &= 67108863, s = Math.imul(rt, ht), r = Math.imul(rt, ut), r = r + Math.imul(H, ht) | 0, a = Math.imul(H, ut), s = s + Math.imul(k, lt) | 0, r = r + Math.imul(k, G) | 0, r = r + Math.imul(D, lt) | 0, a = a + Math.imul(D, G) | 0, s = s + Math.imul(b, F) | 0, r = r + Math.imul(b, V) | 0, r = r + Math.imul(R, F) | 0, a = a + Math.imul(R, V) | 0;
      var W = (v + s | 0) + ((r & 8191) << 13) | 0;
      v = (a + (r >>> 13) | 0) + (W >>> 26) | 0, W &= 67108863, s = Math.imul(et, ht), r = Math.imul(et, ut), r = r + Math.imul(q, ht) | 0, a = Math.imul(q, ut), s = s + Math.imul(rt, lt) | 0, r = r + Math.imul(rt, G) | 0, r = r + Math.imul(H, lt) | 0, a = a + Math.imul(H, G) | 0, s = s + Math.imul(k, F) | 0, r = r + Math.imul(k, V) | 0, r = r + Math.imul(D, F) | 0, a = a + Math.imul(D, V) | 0, s = s + Math.imul(b, Q) | 0, r = r + Math.imul(b, ct) | 0, r = r + Math.imul(R, Q) | 0, a = a + Math.imul(R, ct) | 0;
      var j = (v + s | 0) + ((r & 8191) << 13) | 0;
      v = (a + (r >>> 13) | 0) + (j >>> 26) | 0, j &= 67108863, s = Math.imul(Z, ht), r = Math.imul(Z, ut), r = r + Math.imul(X, ht) | 0, a = Math.imul(X, ut), s = s + Math.imul(et, lt) | 0, r = r + Math.imul(et, G) | 0, r = r + Math.imul(q, lt) | 0, a = a + Math.imul(q, G) | 0, s = s + Math.imul(rt, F) | 0, r = r + Math.imul(rt, V) | 0, r = r + Math.imul(H, F) | 0, a = a + Math.imul(H, V) | 0, s = s + Math.imul(k, Q) | 0, r = r + Math.imul(k, ct) | 0, r = r + Math.imul(D, Q) | 0, a = a + Math.imul(D, ct) | 0, s = s + Math.imul(b, dt) | 0, r = r + Math.imul(b, tt) | 0, r = r + Math.imul(R, dt) | 0, a = a + Math.imul(R, tt) | 0;
      var Nt = (v + s | 0) + ((r & 8191) << 13) | 0;
      v = (a + (r >>> 13) | 0) + (Nt >>> 26) | 0, Nt &= 67108863, s = Math.imul(it, ht), r = Math.imul(it, ut), r = r + Math.imul(nt, ht) | 0, a = Math.imul(nt, ut), s = s + Math.imul(Z, lt) | 0, r = r + Math.imul(Z, G) | 0, r = r + Math.imul(X, lt) | 0, a = a + Math.imul(X, G) | 0, s = s + Math.imul(et, F) | 0, r = r + Math.imul(et, V) | 0, r = r + Math.imul(q, F) | 0, a = a + Math.imul(q, V) | 0, s = s + Math.imul(rt, Q) | 0, r = r + Math.imul(rt, ct) | 0, r = r + Math.imul(H, Q) | 0, a = a + Math.imul(H, ct) | 0, s = s + Math.imul(k, dt) | 0, r = r + Math.imul(k, tt) | 0, r = r + Math.imul(D, dt) | 0, a = a + Math.imul(D, tt) | 0, s = s + Math.imul(b, mt) | 0, r = r + Math.imul(b, pt) | 0, r = r + Math.imul(R, mt) | 0, a = a + Math.imul(R, pt) | 0;
      var kt = (v + s | 0) + ((r & 8191) << 13) | 0;
      v = (a + (r >>> 13) | 0) + (kt >>> 26) | 0, kt &= 67108863, s = Math.imul(ot, ht), r = Math.imul(ot, ut), r = r + Math.imul(st, ht) | 0, a = Math.imul(st, ut), s = s + Math.imul(it, lt) | 0, r = r + Math.imul(it, G) | 0, r = r + Math.imul(nt, lt) | 0, a = a + Math.imul(nt, G) | 0, s = s + Math.imul(Z, F) | 0, r = r + Math.imul(Z, V) | 0, r = r + Math.imul(X, F) | 0, a = a + Math.imul(X, V) | 0, s = s + Math.imul(et, Q) | 0, r = r + Math.imul(et, ct) | 0, r = r + Math.imul(q, Q) | 0, a = a + Math.imul(q, ct) | 0, s = s + Math.imul(rt, dt) | 0, r = r + Math.imul(rt, tt) | 0, r = r + Math.imul(H, dt) | 0, a = a + Math.imul(H, tt) | 0, s = s + Math.imul(k, mt) | 0, r = r + Math.imul(k, pt) | 0, r = r + Math.imul(D, mt) | 0, a = a + Math.imul(D, pt) | 0, s = s + Math.imul(b, vt) | 0, r = r + Math.imul(b, gt) | 0, r = r + Math.imul(R, vt) | 0, a = a + Math.imul(R, gt) | 0;
      var Jt = (v + s | 0) + ((r & 8191) << 13) | 0;
      v = (a + (r >>> 13) | 0) + (Jt >>> 26) | 0, Jt &= 67108863, s = Math.imul(K, ht), r = Math.imul(K, ut), r = r + Math.imul($, ht) | 0, a = Math.imul($, ut), s = s + Math.imul(ot, lt) | 0, r = r + Math.imul(ot, G) | 0, r = r + Math.imul(st, lt) | 0, a = a + Math.imul(st, G) | 0, s = s + Math.imul(it, F) | 0, r = r + Math.imul(it, V) | 0, r = r + Math.imul(nt, F) | 0, a = a + Math.imul(nt, V) | 0, s = s + Math.imul(Z, Q) | 0, r = r + Math.imul(Z, ct) | 0, r = r + Math.imul(X, Q) | 0, a = a + Math.imul(X, ct) | 0, s = s + Math.imul(et, dt) | 0, r = r + Math.imul(et, tt) | 0, r = r + Math.imul(q, dt) | 0, a = a + Math.imul(q, tt) | 0, s = s + Math.imul(rt, mt) | 0, r = r + Math.imul(rt, pt) | 0, r = r + Math.imul(H, mt) | 0, a = a + Math.imul(H, pt) | 0, s = s + Math.imul(k, vt) | 0, r = r + Math.imul(k, gt) | 0, r = r + Math.imul(D, vt) | 0, a = a + Math.imul(D, gt) | 0, s = s + Math.imul(b, wt) | 0, r = r + Math.imul(b, h) | 0, r = r + Math.imul(R, wt) | 0, a = a + Math.imul(R, h) | 0;
      var It = (v + s | 0) + ((r & 8191) << 13) | 0;
      v = (a + (r >>> 13) | 0) + (It >>> 26) | 0, It &= 67108863, s = Math.imul(Y, ht), r = Math.imul(Y, ut), r = r + Math.imul(J, ht) | 0, a = Math.imul(J, ut), s = s + Math.imul(K, lt) | 0, r = r + Math.imul(K, G) | 0, r = r + Math.imul($, lt) | 0, a = a + Math.imul($, G) | 0, s = s + Math.imul(ot, F) | 0, r = r + Math.imul(ot, V) | 0, r = r + Math.imul(st, F) | 0, a = a + Math.imul(st, V) | 0, s = s + Math.imul(it, Q) | 0, r = r + Math.imul(it, ct) | 0, r = r + Math.imul(nt, Q) | 0, a = a + Math.imul(nt, ct) | 0, s = s + Math.imul(Z, dt) | 0, r = r + Math.imul(Z, tt) | 0, r = r + Math.imul(X, dt) | 0, a = a + Math.imul(X, tt) | 0, s = s + Math.imul(et, mt) | 0, r = r + Math.imul(et, pt) | 0, r = r + Math.imul(q, mt) | 0, a = a + Math.imul(q, pt) | 0, s = s + Math.imul(rt, vt) | 0, r = r + Math.imul(rt, gt) | 0, r = r + Math.imul(H, vt) | 0, a = a + Math.imul(H, gt) | 0, s = s + Math.imul(k, wt) | 0, r = r + Math.imul(k, h) | 0, r = r + Math.imul(D, wt) | 0, a = a + Math.imul(D, h) | 0, s = s + Math.imul(b, M) | 0, r = r + Math.imul(b, x) | 0, r = r + Math.imul(R, M) | 0, a = a + Math.imul(R, x) | 0;
      var Or = (v + s | 0) + ((r & 8191) << 13) | 0;
      v = (a + (r >>> 13) | 0) + (Or >>> 26) | 0, Or &= 67108863, s = Math.imul(ft, ht), r = Math.imul(ft, ut), r = r + Math.imul(at, ht) | 0, a = Math.imul(at, ut), s = s + Math.imul(Y, lt) | 0, r = r + Math.imul(Y, G) | 0, r = r + Math.imul(J, lt) | 0, a = a + Math.imul(J, G) | 0, s = s + Math.imul(K, F) | 0, r = r + Math.imul(K, V) | 0, r = r + Math.imul($, F) | 0, a = a + Math.imul($, V) | 0, s = s + Math.imul(ot, Q) | 0, r = r + Math.imul(ot, ct) | 0, r = r + Math.imul(st, Q) | 0, a = a + Math.imul(st, ct) | 0, s = s + Math.imul(it, dt) | 0, r = r + Math.imul(it, tt) | 0, r = r + Math.imul(nt, dt) | 0, a = a + Math.imul(nt, tt) | 0, s = s + Math.imul(Z, mt) | 0, r = r + Math.imul(Z, pt) | 0, r = r + Math.imul(X, mt) | 0, a = a + Math.imul(X, pt) | 0, s = s + Math.imul(et, vt) | 0, r = r + Math.imul(et, gt) | 0, r = r + Math.imul(q, vt) | 0, a = a + Math.imul(q, gt) | 0, s = s + Math.imul(rt, wt) | 0, r = r + Math.imul(rt, h) | 0, r = r + Math.imul(H, wt) | 0, a = a + Math.imul(H, h) | 0, s = s + Math.imul(k, M) | 0, r = r + Math.imul(k, x) | 0, r = r + Math.imul(D, M) | 0, a = a + Math.imul(D, x) | 0, s = s + Math.imul(b, N) | 0, r = r + Math.imul(b, E) | 0, r = r + Math.imul(R, N) | 0, a = a + Math.imul(R, E) | 0;
      var Pr = (v + s | 0) + ((r & 8191) << 13) | 0;
      v = (a + (r >>> 13) | 0) + (Pr >>> 26) | 0, Pr &= 67108863, s = Math.imul(ft, lt), r = Math.imul(ft, G), r = r + Math.imul(at, lt) | 0, a = Math.imul(at, G), s = s + Math.imul(Y, F) | 0, r = r + Math.imul(Y, V) | 0, r = r + Math.imul(J, F) | 0, a = a + Math.imul(J, V) | 0, s = s + Math.imul(K, Q) | 0, r = r + Math.imul(K, ct) | 0, r = r + Math.imul($, Q) | 0, a = a + Math.imul($, ct) | 0, s = s + Math.imul(ot, dt) | 0, r = r + Math.imul(ot, tt) | 0, r = r + Math.imul(st, dt) | 0, a = a + Math.imul(st, tt) | 0, s = s + Math.imul(it, mt) | 0, r = r + Math.imul(it, pt) | 0, r = r + Math.imul(nt, mt) | 0, a = a + Math.imul(nt, pt) | 0, s = s + Math.imul(Z, vt) | 0, r = r + Math.imul(Z, gt) | 0, r = r + Math.imul(X, vt) | 0, a = a + Math.imul(X, gt) | 0, s = s + Math.imul(et, wt) | 0, r = r + Math.imul(et, h) | 0, r = r + Math.imul(q, wt) | 0, a = a + Math.imul(q, h) | 0, s = s + Math.imul(rt, M) | 0, r = r + Math.imul(rt, x) | 0, r = r + Math.imul(H, M) | 0, a = a + Math.imul(H, x) | 0, s = s + Math.imul(k, N) | 0, r = r + Math.imul(k, E) | 0, r = r + Math.imul(D, N) | 0, a = a + Math.imul(D, E) | 0;
      var Ur = (v + s | 0) + ((r & 8191) << 13) | 0;
      v = (a + (r >>> 13) | 0) + (Ur >>> 26) | 0, Ur &= 67108863, s = Math.imul(ft, F), r = Math.imul(ft, V), r = r + Math.imul(at, F) | 0, a = Math.imul(at, V), s = s + Math.imul(Y, Q) | 0, r = r + Math.imul(Y, ct) | 0, r = r + Math.imul(J, Q) | 0, a = a + Math.imul(J, ct) | 0, s = s + Math.imul(K, dt) | 0, r = r + Math.imul(K, tt) | 0, r = r + Math.imul($, dt) | 0, a = a + Math.imul($, tt) | 0, s = s + Math.imul(ot, mt) | 0, r = r + Math.imul(ot, pt) | 0, r = r + Math.imul(st, mt) | 0, a = a + Math.imul(st, pt) | 0, s = s + Math.imul(it, vt) | 0, r = r + Math.imul(it, gt) | 0, r = r + Math.imul(nt, vt) | 0, a = a + Math.imul(nt, gt) | 0, s = s + Math.imul(Z, wt) | 0, r = r + Math.imul(Z, h) | 0, r = r + Math.imul(X, wt) | 0, a = a + Math.imul(X, h) | 0, s = s + Math.imul(et, M) | 0, r = r + Math.imul(et, x) | 0, r = r + Math.imul(q, M) | 0, a = a + Math.imul(q, x) | 0, s = s + Math.imul(rt, N) | 0, r = r + Math.imul(rt, E) | 0, r = r + Math.imul(H, N) | 0, a = a + Math.imul(H, E) | 0;
      var Lr = (v + s | 0) + ((r & 8191) << 13) | 0;
      v = (a + (r >>> 13) | 0) + (Lr >>> 26) | 0, Lr &= 67108863, s = Math.imul(ft, Q), r = Math.imul(ft, ct), r = r + Math.imul(at, Q) | 0, a = Math.imul(at, ct), s = s + Math.imul(Y, dt) | 0, r = r + Math.imul(Y, tt) | 0, r = r + Math.imul(J, dt) | 0, a = a + Math.imul(J, tt) | 0, s = s + Math.imul(K, mt) | 0, r = r + Math.imul(K, pt) | 0, r = r + Math.imul($, mt) | 0, a = a + Math.imul($, pt) | 0, s = s + Math.imul(ot, vt) | 0, r = r + Math.imul(ot, gt) | 0, r = r + Math.imul(st, vt) | 0, a = a + Math.imul(st, gt) | 0, s = s + Math.imul(it, wt) | 0, r = r + Math.imul(it, h) | 0, r = r + Math.imul(nt, wt) | 0, a = a + Math.imul(nt, h) | 0, s = s + Math.imul(Z, M) | 0, r = r + Math.imul(Z, x) | 0, r = r + Math.imul(X, M) | 0, a = a + Math.imul(X, x) | 0, s = s + Math.imul(et, N) | 0, r = r + Math.imul(et, E) | 0, r = r + Math.imul(q, N) | 0, a = a + Math.imul(q, E) | 0;
      var Cr = (v + s | 0) + ((r & 8191) << 13) | 0;
      v = (a + (r >>> 13) | 0) + (Cr >>> 26) | 0, Cr &= 67108863, s = Math.imul(ft, dt), r = Math.imul(ft, tt), r = r + Math.imul(at, dt) | 0, a = Math.imul(at, tt), s = s + Math.imul(Y, mt) | 0, r = r + Math.imul(Y, pt) | 0, r = r + Math.imul(J, mt) | 0, a = a + Math.imul(J, pt) | 0, s = s + Math.imul(K, vt) | 0, r = r + Math.imul(K, gt) | 0, r = r + Math.imul($, vt) | 0, a = a + Math.imul($, gt) | 0, s = s + Math.imul(ot, wt) | 0, r = r + Math.imul(ot, h) | 0, r = r + Math.imul(st, wt) | 0, a = a + Math.imul(st, h) | 0, s = s + Math.imul(it, M) | 0, r = r + Math.imul(it, x) | 0, r = r + Math.imul(nt, M) | 0, a = a + Math.imul(nt, x) | 0, s = s + Math.imul(Z, N) | 0, r = r + Math.imul(Z, E) | 0, r = r + Math.imul(X, N) | 0, a = a + Math.imul(X, E) | 0;
      var kr = (v + s | 0) + ((r & 8191) << 13) | 0;
      v = (a + (r >>> 13) | 0) + (kr >>> 26) | 0, kr &= 67108863, s = Math.imul(ft, mt), r = Math.imul(ft, pt), r = r + Math.imul(at, mt) | 0, a = Math.imul(at, pt), s = s + Math.imul(Y, vt) | 0, r = r + Math.imul(Y, gt) | 0, r = r + Math.imul(J, vt) | 0, a = a + Math.imul(J, gt) | 0, s = s + Math.imul(K, wt) | 0, r = r + Math.imul(K, h) | 0, r = r + Math.imul($, wt) | 0, a = a + Math.imul($, h) | 0, s = s + Math.imul(ot, M) | 0, r = r + Math.imul(ot, x) | 0, r = r + Math.imul(st, M) | 0, a = a + Math.imul(st, x) | 0, s = s + Math.imul(it, N) | 0, r = r + Math.imul(it, E) | 0, r = r + Math.imul(nt, N) | 0, a = a + Math.imul(nt, E) | 0;
      var Dr = (v + s | 0) + ((r & 8191) << 13) | 0;
      v = (a + (r >>> 13) | 0) + (Dr >>> 26) | 0, Dr &= 67108863, s = Math.imul(ft, vt), r = Math.imul(ft, gt), r = r + Math.imul(at, vt) | 0, a = Math.imul(at, gt), s = s + Math.imul(Y, wt) | 0, r = r + Math.imul(Y, h) | 0, r = r + Math.imul(J, wt) | 0, a = a + Math.imul(J, h) | 0, s = s + Math.imul(K, M) | 0, r = r + Math.imul(K, x) | 0, r = r + Math.imul($, M) | 0, a = a + Math.imul($, x) | 0, s = s + Math.imul(ot, N) | 0, r = r + Math.imul(ot, E) | 0, r = r + Math.imul(st, N) | 0, a = a + Math.imul(st, E) | 0;
      var Fr = (v + s | 0) + ((r & 8191) << 13) | 0;
      v = (a + (r >>> 13) | 0) + (Fr >>> 26) | 0, Fr &= 67108863, s = Math.imul(ft, wt), r = Math.imul(ft, h), r = r + Math.imul(at, wt) | 0, a = Math.imul(at, h), s = s + Math.imul(Y, M) | 0, r = r + Math.imul(Y, x) | 0, r = r + Math.imul(J, M) | 0, a = a + Math.imul(J, x) | 0, s = s + Math.imul(K, N) | 0, r = r + Math.imul(K, E) | 0, r = r + Math.imul($, N) | 0, a = a + Math.imul($, E) | 0;
      var Br = (v + s | 0) + ((r & 8191) << 13) | 0;
      v = (a + (r >>> 13) | 0) + (Br >>> 26) | 0, Br &= 67108863, s = Math.imul(ft, M), r = Math.imul(ft, x), r = r + Math.imul(at, M) | 0, a = Math.imul(at, x), s = s + Math.imul(Y, N) | 0, r = r + Math.imul(Y, E) | 0, r = r + Math.imul(J, N) | 0, a = a + Math.imul(J, E) | 0;
      var $r = (v + s | 0) + ((r & 8191) << 13) | 0;
      v = (a + (r >>> 13) | 0) + ($r >>> 26) | 0, $r &= 67108863, s = Math.imul(ft, N), r = Math.imul(ft, E), r = r + Math.imul(at, N) | 0, a = Math.imul(at, E);
      var qr = (v + s | 0) + ((r & 8191) << 13) | 0;
      return v = (a + (r >>> 13) | 0) + (qr >>> 26) | 0, qr &= 67108863, p[0] = S, p[1] = _t, p[2] = W, p[3] = j, p[4] = Nt, p[5] = kt, p[6] = Jt, p[7] = It, p[8] = Or, p[9] = Pr, p[10] = Ur, p[11] = Lr, p[12] = Cr, p[13] = kr, p[14] = Dr, p[15] = Fr, p[16] = Br, p[17] = $r, p[18] = qr, v !== 0 && (p[19] = v, o.length++), o;
    };
    Math.imul || (bt = Ft);
    function wr(m, t, e) {
      e.negative = t.negative ^ m.negative, e.length = m.length + t.length;
      for (var o = 0, f = 0, c = 0; c < e.length - 1; c++) {
        var p = f;
        f = 0;
        for (var v = o & 67108863, s = Math.min(c, t.length - 1), r = Math.max(0, c - m.length + 1); r <= s; r++) {
          var a = c - r, A = m.words[a] | 0, b = t.words[r] | 0, R = A * b, xt = R & 67108863;
          p = p + (R / 67108864 | 0) | 0, xt = xt + v | 0, v = xt & 67108863, p = p + (xt >>> 26) | 0, f += p >>> 26, p &= 67108863;
        }
        e.words[c] = v, o = p, p = f;
      }
      return o !== 0 ? e.words[c] = o : e.length--, e._strip();
    }
    function Mr(m, t, e) {
      return wr(m, t, e);
    }
    l.prototype.mulTo = function(t, e) {
      var o, f = this.length + t.length;
      return this.length === 10 && t.length === 10 ? o = bt(this, t, e) : f < 63 ? o = Ft(this, t, e) : f < 1024 ? o = wr(this, t, e) : o = Mr(this, t, e), o;
    }, l.prototype.mul = function(t) {
      var e = new l(null);
      return e.words = new Array(this.length + t.length), this.mulTo(t, e);
    }, l.prototype.mulf = function(t) {
      var e = new l(null);
      return e.words = new Array(this.length + t.length), Mr(this, t, e);
    }, l.prototype.imul = function(t) {
      return this.clone().mulTo(t, this);
    }, l.prototype.imuln = function(t) {
      var e = t < 0;
      e && (t = -t), d(typeof t == "number"), d(t < 67108864);
      for (var o = 0, f = 0; f < this.length; f++) {
        var c = (this.words[f] | 0) * t, p = (c & 67108863) + (o & 67108863);
        o >>= 26, o += c / 67108864 | 0, o += p >>> 26, this.words[f] = p & 67108863;
      }
      return o !== 0 && (this.words[f] = o, this.length++), e ? this.ineg() : this;
    }, l.prototype.muln = function(t) {
      return this.clone().imuln(t);
    }, l.prototype.sqr = function() {
      return this.mul(this);
    }, l.prototype.isqr = function() {
      return this.imul(this.clone());
    }, l.prototype.pow = function(t) {
      var e = er(t);
      if (e.length === 0)
        return new l(1);
      for (var o = this, f = 0; f < e.length && e[f] === 0; f++, o = o.sqr())
        ;
      if (++f < e.length)
        for (var c = o.sqr(); f < e.length; f++, c = c.sqr())
          e[f] !== 0 && (o = o.mul(c));
      return o;
    }, l.prototype.iushln = function(t) {
      d(typeof t == "number" && t >= 0);
      var e = t % 26, o = (t - e) / 26, f = 67108863 >>> 26 - e << 26 - e, c;
      if (e !== 0) {
        var p = 0;
        for (c = 0; c < this.length; c++) {
          var v = this.words[c] & f, s = (this.words[c] | 0) - v << e;
          this.words[c] = s | p, p = v >>> 26 - e;
        }
        p && (this.words[c] = p, this.length++);
      }
      if (o !== 0) {
        for (c = this.length - 1; c >= 0; c--)
          this.words[c + o] = this.words[c];
        for (c = 0; c < o; c++)
          this.words[c] = 0;
        this.length += o;
      }
      return this._strip();
    }, l.prototype.ishln = function(t) {
      return d(this.negative === 0), this.iushln(t);
    }, l.prototype.iushrn = function(t, e, o) {
      d(typeof t == "number" && t >= 0);
      var f;
      e ? f = (e - e % 26) / 26 : f = 0;
      var c = t % 26, p = Math.min((t - c) / 26, this.length), v = 67108863 ^ 67108863 >>> c << c, s = o;
      if (f -= p, f = Math.max(0, f), s) {
        for (var r = 0; r < p; r++)
          s.words[r] = this.words[r];
        s.length = p;
      }
      if (p !== 0)
        if (this.length > p)
          for (this.length -= p, r = 0; r < this.length; r++)
            this.words[r] = this.words[r + p];
        else
          this.words[0] = 0, this.length = 1;
      var a = 0;
      for (r = this.length - 1; r >= 0 && (a !== 0 || r >= f); r--) {
        var A = this.words[r] | 0;
        this.words[r] = a << 26 - c | A >>> c, a = A & v;
      }
      return s && a !== 0 && (s.words[s.length++] = a), this.length === 0 && (this.words[0] = 0, this.length = 1), this._strip();
    }, l.prototype.ishrn = function(t, e, o) {
      return d(this.negative === 0), this.iushrn(t, e, o);
    }, l.prototype.shln = function(t) {
      return this.clone().ishln(t);
    }, l.prototype.ushln = function(t) {
      return this.clone().iushln(t);
    }, l.prototype.shrn = function(t) {
      return this.clone().ishrn(t);
    }, l.prototype.ushrn = function(t) {
      return this.clone().iushrn(t);
    }, l.prototype.testn = function(t) {
      d(typeof t == "number" && t >= 0);
      var e = t % 26, o = (t - e) / 26, f = 1 << e;
      if (this.length <= o)
        return !1;
      var c = this.words[o];
      return !!(c & f);
    }, l.prototype.imaskn = function(t) {
      d(typeof t == "number" && t >= 0);
      var e = t % 26, o = (t - e) / 26;
      if (d(this.negative === 0, "imaskn works only with positive numbers"), this.length <= o)
        return this;
      if (e !== 0 && o++, this.length = Math.min(o, this.length), e !== 0) {
        var f = 67108863 ^ 67108863 >>> e << e;
        this.words[this.length - 1] &= f;
      }
      return this._strip();
    }, l.prototype.maskn = function(t) {
      return this.clone().imaskn(t);
    }, l.prototype.iaddn = function(t) {
      return d(typeof t == "number"), d(t < 67108864), t < 0 ? this.isubn(-t) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) <= t ? (this.words[0] = t - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(t), this.negative = 1, this) : this._iaddn(t);
    }, l.prototype._iaddn = function(t) {
      this.words[0] += t;
      for (var e = 0; e < this.length && this.words[e] >= 67108864; e++)
        this.words[e] -= 67108864, e === this.length - 1 ? this.words[e + 1] = 1 : this.words[e + 1]++;
      return this.length = Math.max(this.length, e + 1), this;
    }, l.prototype.isubn = function(t) {
      if (d(typeof t == "number"), d(t < 67108864), t < 0)
        return this.iaddn(-t);
      if (this.negative !== 0)
        return this.negative = 0, this.iaddn(t), this.negative = 1, this;
      if (this.words[0] -= t, this.length === 1 && this.words[0] < 0)
        this.words[0] = -this.words[0], this.negative = 1;
      else
        for (var e = 0; e < this.length && this.words[e] < 0; e++)
          this.words[e] += 67108864, this.words[e + 1] -= 1;
      return this._strip();
    }, l.prototype.addn = function(t) {
      return this.clone().iaddn(t);
    }, l.prototype.subn = function(t) {
      return this.clone().isubn(t);
    }, l.prototype.iabs = function() {
      return this.negative = 0, this;
    }, l.prototype.abs = function() {
      return this.clone().iabs();
    }, l.prototype._ishlnsubmul = function(t, e, o) {
      var f = t.length + o, c;
      this._expand(f);
      var p, v = 0;
      for (c = 0; c < t.length; c++) {
        p = (this.words[c + o] | 0) + v;
        var s = (t.words[c] | 0) * e;
        p -= s & 67108863, v = (p >> 26) - (s / 67108864 | 0), this.words[c + o] = p & 67108863;
      }
      for (; c < this.length - o; c++)
        p = (this.words[c + o] | 0) + v, v = p >> 26, this.words[c + o] = p & 67108863;
      if (v === 0)
        return this._strip();
      for (d(v === -1), v = 0, c = 0; c < this.length; c++)
        p = -(this.words[c] | 0) + v, v = p >> 26, this.words[c] = p & 67108863;
      return this.negative = 1, this._strip();
    }, l.prototype._wordDiv = function(t, e) {
      var o = this.length - t.length, f = this.clone(), c = t, p = c.words[c.length - 1] | 0, v = this._countBits(p);
      o = 26 - v, o !== 0 && (c = c.ushln(o), f.iushln(o), p = c.words[c.length - 1] | 0);
      var s = f.length - c.length, r;
      if (e !== "mod") {
        r = new l(null), r.length = s + 1, r.words = new Array(r.length);
        for (var a = 0; a < r.length; a++)
          r.words[a] = 0;
      }
      var A = f.clone()._ishlnsubmul(c, 1, s);
      A.negative === 0 && (f = A, r && (r.words[s] = 1));
      for (var b = s - 1; b >= 0; b--) {
        var R = (f.words[c.length + b] | 0) * 67108864 + (f.words[c.length + b - 1] | 0);
        for (R = Math.min(R / p | 0, 67108863), f._ishlnsubmul(c, R, b); f.negative !== 0; )
          R--, f.negative = 0, f._ishlnsubmul(c, 1, b), f.isZero() || (f.negative ^= 1);
        r && (r.words[b] = R);
      }
      return r && r._strip(), f._strip(), e !== "div" && o !== 0 && f.iushrn(o), {
        div: r || null,
        mod: f
      };
    }, l.prototype.divmod = function(t, e, o) {
      if (d(!t.isZero()), this.isZero())
        return {
          div: new l(0),
          mod: new l(0)
        };
      var f, c, p;
      return this.negative !== 0 && t.negative === 0 ? (p = this.neg().divmod(t, e), e !== "mod" && (f = p.div.neg()), e !== "div" && (c = p.mod.neg(), o && c.negative !== 0 && c.iadd(t)), {
        div: f,
        mod: c
      }) : this.negative === 0 && t.negative !== 0 ? (p = this.divmod(t.neg(), e), e !== "mod" && (f = p.div.neg()), {
        div: f,
        mod: p.mod
      }) : (this.negative & t.negative) !== 0 ? (p = this.neg().divmod(t.neg(), e), e !== "div" && (c = p.mod.neg(), o && c.negative !== 0 && c.isub(t)), {
        div: p.div,
        mod: c
      }) : t.length > this.length || this.cmp(t) < 0 ? {
        div: new l(0),
        mod: this
      } : t.length === 1 ? e === "div" ? {
        div: this.divn(t.words[0]),
        mod: null
      } : e === "mod" ? {
        div: null,
        mod: new l(this.modrn(t.words[0]))
      } : {
        div: this.divn(t.words[0]),
        mod: new l(this.modrn(t.words[0]))
      } : this._wordDiv(t, e);
    }, l.prototype.div = function(t) {
      return this.divmod(t, "div", !1).div;
    }, l.prototype.mod = function(t) {
      return this.divmod(t, "mod", !1).mod;
    }, l.prototype.umod = function(t) {
      return this.divmod(t, "mod", !0).mod;
    }, l.prototype.divRound = function(t) {
      var e = this.divmod(t);
      if (e.mod.isZero())
        return e.div;
      var o = e.div.negative !== 0 ? e.mod.isub(t) : e.mod, f = t.ushrn(1), c = t.andln(1), p = o.cmp(f);
      return p < 0 || c === 1 && p === 0 ? e.div : e.div.negative !== 0 ? e.div.isubn(1) : e.div.iaddn(1);
    }, l.prototype.modrn = function(t) {
      var e = t < 0;
      e && (t = -t), d(t <= 67108863);
      for (var o = (1 << 26) % t, f = 0, c = this.length - 1; c >= 0; c--)
        f = (o * f + (this.words[c] | 0)) % t;
      return e ? -f : f;
    }, l.prototype.modn = function(t) {
      return this.modrn(t);
    }, l.prototype.idivn = function(t) {
      var e = t < 0;
      e && (t = -t), d(t <= 67108863);
      for (var o = 0, f = this.length - 1; f >= 0; f--) {
        var c = (this.words[f] | 0) + o * 67108864;
        this.words[f] = c / t | 0, o = c % t;
      }
      return this._strip(), e ? this.ineg() : this;
    }, l.prototype.divn = function(t) {
      return this.clone().idivn(t);
    }, l.prototype.egcd = function(t) {
      d(t.negative === 0), d(!t.isZero());
      var e = this, o = t.clone();
      e.negative !== 0 ? e = e.umod(t) : e = e.clone();
      for (var f = new l(1), c = new l(0), p = new l(0), v = new l(1), s = 0; e.isEven() && o.isEven(); )
        e.iushrn(1), o.iushrn(1), ++s;
      for (var r = o.clone(), a = e.clone(); !e.isZero(); ) {
        for (var A = 0, b = 1; (e.words[0] & b) === 0 && A < 26; ++A, b <<= 1)
          ;
        if (A > 0)
          for (e.iushrn(A); A-- > 0; )
            (f.isOdd() || c.isOdd()) && (f.iadd(r), c.isub(a)), f.iushrn(1), c.iushrn(1);
        for (var R = 0, xt = 1; (o.words[0] & xt) === 0 && R < 26; ++R, xt <<= 1)
          ;
        if (R > 0)
          for (o.iushrn(R); R-- > 0; )
            (p.isOdd() || v.isOdd()) && (p.iadd(r), v.isub(a)), p.iushrn(1), v.iushrn(1);
        e.cmp(o) >= 0 ? (e.isub(o), f.isub(p), c.isub(v)) : (o.isub(e), p.isub(f), v.isub(c));
      }
      return {
        a: p,
        b: v,
        gcd: o.iushln(s)
      };
    }, l.prototype._invmp = function(t) {
      d(t.negative === 0), d(!t.isZero());
      var e = this, o = t.clone();
      e.negative !== 0 ? e = e.umod(t) : e = e.clone();
      for (var f = new l(1), c = new l(0), p = o.clone(); e.cmpn(1) > 0 && o.cmpn(1) > 0; ) {
        for (var v = 0, s = 1; (e.words[0] & s) === 0 && v < 26; ++v, s <<= 1)
          ;
        if (v > 0)
          for (e.iushrn(v); v-- > 0; )
            f.isOdd() && f.iadd(p), f.iushrn(1);
        for (var r = 0, a = 1; (o.words[0] & a) === 0 && r < 26; ++r, a <<= 1)
          ;
        if (r > 0)
          for (o.iushrn(r); r-- > 0; )
            c.isOdd() && c.iadd(p), c.iushrn(1);
        e.cmp(o) >= 0 ? (e.isub(o), f.isub(c)) : (o.isub(e), c.isub(f));
      }
      var A;
      return e.cmpn(1) === 0 ? A = f : A = c, A.cmpn(0) < 0 && A.iadd(t), A;
    }, l.prototype.gcd = function(t) {
      if (this.isZero())
        return t.abs();
      if (t.isZero())
        return this.abs();
      var e = this.clone(), o = t.clone();
      e.negative = 0, o.negative = 0;
      for (var f = 0; e.isEven() && o.isEven(); f++)
        e.iushrn(1), o.iushrn(1);
      do {
        for (; e.isEven(); )
          e.iushrn(1);
        for (; o.isEven(); )
          o.iushrn(1);
        var c = e.cmp(o);
        if (c < 0) {
          var p = e;
          e = o, o = p;
        } else if (c === 0 || o.cmpn(1) === 0)
          break;
        e.isub(o);
      } while (!0);
      return o.iushln(f);
    }, l.prototype.invm = function(t) {
      return this.egcd(t).a.umod(t);
    }, l.prototype.isEven = function() {
      return (this.words[0] & 1) === 0;
    }, l.prototype.isOdd = function() {
      return (this.words[0] & 1) === 1;
    }, l.prototype.andln = function(t) {
      return this.words[0] & t;
    }, l.prototype.bincn = function(t) {
      d(typeof t == "number");
      var e = t % 26, o = (t - e) / 26, f = 1 << e;
      if (this.length <= o)
        return this._expand(o + 1), this.words[o] |= f, this;
      for (var c = f, p = o; c !== 0 && p < this.length; p++) {
        var v = this.words[p] | 0;
        v += c, c = v >>> 26, v &= 67108863, this.words[p] = v;
      }
      return c !== 0 && (this.words[p] = c, this.length++), this;
    }, l.prototype.isZero = function() {
      return this.length === 1 && this.words[0] === 0;
    }, l.prototype.cmpn = function(t) {
      var e = t < 0;
      if (this.negative !== 0 && !e)
        return -1;
      if (this.negative === 0 && e)
        return 1;
      this._strip();
      var o;
      if (this.length > 1)
        o = 1;
      else {
        e && (t = -t), d(t <= 67108863, "Number is too big");
        var f = this.words[0] | 0;
        o = f === t ? 0 : f < t ? -1 : 1;
      }
      return this.negative !== 0 ? -o | 0 : o;
    }, l.prototype.cmp = function(t) {
      if (this.negative !== 0 && t.negative === 0)
        return -1;
      if (this.negative === 0 && t.negative !== 0)
        return 1;
      var e = this.ucmp(t);
      return this.negative !== 0 ? -e | 0 : e;
    }, l.prototype.ucmp = function(t) {
      if (this.length > t.length)
        return 1;
      if (this.length < t.length)
        return -1;
      for (var e = 0, o = this.length - 1; o >= 0; o--) {
        var f = this.words[o] | 0, c = t.words[o] | 0;
        if (f !== c) {
          f < c ? e = -1 : f > c && (e = 1);
          break;
        }
      }
      return e;
    }, l.prototype.gtn = function(t) {
      return this.cmpn(t) === 1;
    }, l.prototype.gt = function(t) {
      return this.cmp(t) === 1;
    }, l.prototype.gten = function(t) {
      return this.cmpn(t) >= 0;
    }, l.prototype.gte = function(t) {
      return this.cmp(t) >= 0;
    }, l.prototype.ltn = function(t) {
      return this.cmpn(t) === -1;
    }, l.prototype.lt = function(t) {
      return this.cmp(t) === -1;
    }, l.prototype.lten = function(t) {
      return this.cmpn(t) <= 0;
    }, l.prototype.lte = function(t) {
      return this.cmp(t) <= 0;
    }, l.prototype.eqn = function(t) {
      return this.cmpn(t) === 0;
    }, l.prototype.eq = function(t) {
      return this.cmp(t) === 0;
    }, l.red = function(t) {
      return new z(t);
    }, l.prototype.toRed = function(t) {
      return d(!this.red, "Already a number in reduction context"), d(this.negative === 0, "red works only with positives"), t.convertTo(this)._forceRed(t);
    }, l.prototype.fromRed = function() {
      return d(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
    }, l.prototype._forceRed = function(t) {
      return this.red = t, this;
    }, l.prototype.forceRed = function(t) {
      return d(!this.red, "Already a number in reduction context"), this._forceRed(t);
    }, l.prototype.redAdd = function(t) {
      return d(this.red, "redAdd works only with red numbers"), this.red.add(this, t);
    }, l.prototype.redIAdd = function(t) {
      return d(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, t);
    }, l.prototype.redSub = function(t) {
      return d(this.red, "redSub works only with red numbers"), this.red.sub(this, t);
    }, l.prototype.redISub = function(t) {
      return d(this.red, "redISub works only with red numbers"), this.red.isub(this, t);
    }, l.prototype.redShl = function(t) {
      return d(this.red, "redShl works only with red numbers"), this.red.shl(this, t);
    }, l.prototype.redMul = function(t) {
      return d(this.red, "redMul works only with red numbers"), this.red._verify2(this, t), this.red.mul(this, t);
    }, l.prototype.redIMul = function(t) {
      return d(this.red, "redMul works only with red numbers"), this.red._verify2(this, t), this.red.imul(this, t);
    }, l.prototype.redSqr = function() {
      return d(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
    }, l.prototype.redISqr = function() {
      return d(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
    }, l.prototype.redSqrt = function() {
      return d(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
    }, l.prototype.redInvm = function() {
      return d(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
    }, l.prototype.redNeg = function() {
      return d(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
    }, l.prototype.redPow = function(t) {
      return d(this.red && !t.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, t);
    };
    var ir = {
      k256: null,
      p224: null,
      p192: null,
      p25519: null
    };
    function Tt(m, t) {
      this.name = m, this.p = new l(t, 16), this.n = this.p.bitLength(), this.k = new l(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
    }
    Tt.prototype._tmp = function() {
      var t = new l(null);
      return t.words = new Array(Math.ceil(this.n / 13)), t;
    }, Tt.prototype.ireduce = function(t) {
      var e = t, o;
      do
        this.split(e, this.tmp), e = this.imulK(e), e = e.iadd(this.tmp), o = e.bitLength();
      while (o > this.n);
      var f = o < this.n ? -1 : e.ucmp(this.p);
      return f === 0 ? (e.words[0] = 0, e.length = 1) : f > 0 ? e.isub(this.p) : e.strip !== void 0 ? e.strip() : e._strip(), e;
    }, Tt.prototype.split = function(t, e) {
      t.iushrn(this.n, 0, e);
    }, Tt.prototype.imulK = function(t) {
      return t.imul(this.k);
    };
    function Zt() {
      Tt.call(
        this,
        "k256",
        "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
      );
    }
    g(Zt, Tt), Zt.prototype.split = function(t, e) {
      for (var o = 4194303, f = Math.min(t.length, 9), c = 0; c < f; c++)
        e.words[c] = t.words[c];
      if (e.length = f, t.length <= 9) {
        t.words[0] = 0, t.length = 1;
        return;
      }
      var p = t.words[9];
      for (e.words[e.length++] = p & o, c = 10; c < t.length; c++) {
        var v = t.words[c] | 0;
        t.words[c - 10] = (v & o) << 4 | p >>> 22, p = v;
      }
      p >>>= 22, t.words[c - 10] = p, p === 0 && t.length > 10 ? t.length -= 10 : t.length -= 9;
    }, Zt.prototype.imulK = function(t) {
      t.words[t.length] = 0, t.words[t.length + 1] = 0, t.length += 2;
      for (var e = 0, o = 0; o < t.length; o++) {
        var f = t.words[o] | 0;
        e += f * 977, t.words[o] = e & 67108863, e = f * 64 + (e / 67108864 | 0);
      }
      return t.words[t.length - 1] === 0 && (t.length--, t.words[t.length - 1] === 0 && t.length--), t;
    };
    function yr() {
      Tt.call(
        this,
        "p224",
        "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
      );
    }
    g(yr, Tt);
    function nr() {
      Tt.call(
        this,
        "p192",
        "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
      );
    }
    g(nr, Tt);
    function or() {
      Tt.call(
        this,
        "25519",
        "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
      );
    }
    g(or, Tt), or.prototype.imulK = function(t) {
      for (var e = 0, o = 0; o < t.length; o++) {
        var f = (t.words[o] | 0) * 19 + e, c = f & 67108863;
        f >>>= 26, t.words[o] = c, e = f;
      }
      return e !== 0 && (t.words[t.length++] = e), t;
    }, l._prime = function(t) {
      if (ir[t])
        return ir[t];
      var e;
      if (t === "k256")
        e = new Zt();
      else if (t === "p224")
        e = new yr();
      else if (t === "p192")
        e = new nr();
      else if (t === "p25519")
        e = new or();
      else
        throw new Error("Unknown prime " + t);
      return ir[t] = e, e;
    };
    function z(m) {
      if (typeof m == "string") {
        var t = l._prime(m);
        this.m = t.p, this.prime = t;
      } else
        d(m.gtn(1), "modulus must be greater than 1"), this.m = m, this.prime = null;
    }
    z.prototype._verify1 = function(t) {
      d(t.negative === 0, "red works only with positives"), d(t.red, "red works only with red numbers");
    }, z.prototype._verify2 = function(t, e) {
      d((t.negative | e.negative) === 0, "red works only with positives"), d(
        t.red && t.red === e.red,
        "red works only with red numbers"
      );
    }, z.prototype.imod = function(t) {
      return this.prime ? this.prime.ireduce(t)._forceRed(this) : (C(t, t.umod(this.m)._forceRed(this)), t);
    }, z.prototype.neg = function(t) {
      return t.isZero() ? t.clone() : this.m.sub(t)._forceRed(this);
    }, z.prototype.add = function(t, e) {
      this._verify2(t, e);
      var o = t.add(e);
      return o.cmp(this.m) >= 0 && o.isub(this.m), o._forceRed(this);
    }, z.prototype.iadd = function(t, e) {
      this._verify2(t, e);
      var o = t.iadd(e);
      return o.cmp(this.m) >= 0 && o.isub(this.m), o;
    }, z.prototype.sub = function(t, e) {
      this._verify2(t, e);
      var o = t.sub(e);
      return o.cmpn(0) < 0 && o.iadd(this.m), o._forceRed(this);
    }, z.prototype.isub = function(t, e) {
      this._verify2(t, e);
      var o = t.isub(e);
      return o.cmpn(0) < 0 && o.iadd(this.m), o;
    }, z.prototype.shl = function(t, e) {
      return this._verify1(t), this.imod(t.ushln(e));
    }, z.prototype.imul = function(t, e) {
      return this._verify2(t, e), this.imod(t.imul(e));
    }, z.prototype.mul = function(t, e) {
      return this._verify2(t, e), this.imod(t.mul(e));
    }, z.prototype.isqr = function(t) {
      return this.imul(t, t.clone());
    }, z.prototype.sqr = function(t) {
      return this.mul(t, t);
    }, z.prototype.sqrt = function(t) {
      if (t.isZero())
        return t.clone();
      var e = this.m.andln(3);
      if (d(e % 2 === 1), e === 3) {
        var o = this.m.add(new l(1)).iushrn(2);
        return this.pow(t, o);
      }
      for (var f = this.m.subn(1), c = 0; !f.isZero() && f.andln(1) === 0; )
        c++, f.iushrn(1);
      d(!f.isZero());
      var p = new l(1).toRed(this), v = p.redNeg(), s = this.m.subn(1).iushrn(1), r = this.m.bitLength();
      for (r = new l(2 * r * r).toRed(this); this.pow(r, s).cmp(v) !== 0; )
        r.redIAdd(v);
      for (var a = this.pow(r, f), A = this.pow(t, f.addn(1).iushrn(1)), b = this.pow(t, f), R = c; b.cmp(p) !== 0; ) {
        for (var xt = b, k = 0; xt.cmp(p) !== 0; k++)
          xt = xt.redSqr();
        d(k < R);
        var D = this.pow(a, new l(1).iushln(R - k - 1));
        A = A.redMul(D), a = D.redSqr(), b = b.redMul(a), R = k;
      }
      return A;
    }, z.prototype.invm = function(t) {
      var e = t._invmp(this.m);
      return e.negative !== 0 ? (e.negative = 0, this.imod(e).redNeg()) : this.imod(e);
    }, z.prototype.pow = function(t, e) {
      if (e.isZero())
        return new l(1).toRed(this);
      if (e.cmpn(1) === 0)
        return t.clone();
      var o = 4, f = new Array(1 << o);
      f[0] = new l(1).toRed(this), f[1] = t;
      for (var c = 2; c < f.length; c++)
        f[c] = this.mul(f[c - 1], t);
      var p = f[0], v = 0, s = 0, r = e.bitLength() % 26;
      for (r === 0 && (r = 26), c = e.length - 1; c >= 0; c--) {
        for (var a = e.words[c], A = r - 1; A >= 0; A--) {
          var b = a >> A & 1;
          if (p !== f[0] && (p = this.sqr(p)), b === 0 && v === 0) {
            s = 0;
            continue;
          }
          v <<= 1, v |= b, s++, !(s !== o && (c !== 0 || A !== 0)) && (p = this.mul(p, f[v]), s = 0, v = 0);
        }
        r = 26;
      }
      return p;
    }, z.prototype.convertTo = function(t) {
      var e = t.umod(this.m);
      return e === t ? e.clone() : e;
    }, z.prototype.convertFrom = function(t) {
      var e = t.clone();
      return e.red = null, e;
    }, l.mont = function(t) {
      return new Ct(t);
    };
    function Ct(m) {
      z.call(this, m), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new l(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
    }
    g(Ct, z), Ct.prototype.convertTo = function(t) {
      return this.imod(t.ushln(this.shift));
    }, Ct.prototype.convertFrom = function(t) {
      var e = this.imod(t.mul(this.rinv));
      return e.red = null, e;
    }, Ct.prototype.imul = function(t, e) {
      if (t.isZero() || e.isZero())
        return t.words[0] = 0, t.length = 1, t;
      var o = t.imul(e), f = o.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), c = o.isub(f).iushrn(this.shift), p = c;
      return c.cmp(this.m) >= 0 ? p = c.isub(this.m) : c.cmpn(0) < 0 && (p = c.iadd(this.m)), p._forceRed(this);
    }, Ct.prototype.mul = function(t, e) {
      if (t.isZero() || e.isZero())
        return new l(0)._forceRed(this);
      var o = t.mul(e), f = o.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), c = o.isub(f).iushrn(this.shift), p = c;
      return c.cmp(this.m) >= 0 ? p = c.isub(this.m) : c.cmpn(0) < 0 && (p = c.iadd(this.m)), p._forceRed(this);
    }, Ct.prototype.invm = function(t) {
      var e = this.imod(t._invmp(this.m).mul(this.r2));
      return e._forceRed(this);
    };
  })(i, Se);
})(de);
const Le = de.exports, Ce = "logger/5.7.0";
let Kr = !1, Yr = !1;
const Nr = { debug: 1, default: 2, info: 2, warning: 3, error: 4, off: 5 };
let Jr = Nr.default, Wr = null;
function ke() {
  try {
    const i = [];
    if (["NFD", "NFC", "NFKD", "NFKC"].forEach((n) => {
      try {
        if ("test".normalize(n) !== "test")
          throw new Error("bad normalize");
      } catch {
        i.push(n);
      }
    }), i.length)
      throw new Error("missing " + i.join(", "));
    if (String.fromCharCode(233).normalize("NFD") !== String.fromCharCode(101, 769))
      throw new Error("broken implementation");
  } catch (i) {
    return i.message;
  }
  return null;
}
const Qr = ke();
var zr;
(function(i) {
  i.DEBUG = "DEBUG", i.INFO = "INFO", i.WARNING = "WARNING", i.ERROR = "ERROR", i.OFF = "OFF";
})(zr || (zr = {}));
var Ut;
(function(i) {
  i.UNKNOWN_ERROR = "UNKNOWN_ERROR", i.NOT_IMPLEMENTED = "NOT_IMPLEMENTED", i.UNSUPPORTED_OPERATION = "UNSUPPORTED_OPERATION", i.NETWORK_ERROR = "NETWORK_ERROR", i.SERVER_ERROR = "SERVER_ERROR", i.TIMEOUT = "TIMEOUT", i.BUFFER_OVERRUN = "BUFFER_OVERRUN", i.NUMERIC_FAULT = "NUMERIC_FAULT", i.MISSING_NEW = "MISSING_NEW", i.INVALID_ARGUMENT = "INVALID_ARGUMENT", i.MISSING_ARGUMENT = "MISSING_ARGUMENT", i.UNEXPECTED_ARGUMENT = "UNEXPECTED_ARGUMENT", i.CALL_EXCEPTION = "CALL_EXCEPTION", i.INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS", i.NONCE_EXPIRED = "NONCE_EXPIRED", i.REPLACEMENT_UNDERPRICED = "REPLACEMENT_UNDERPRICED", i.UNPREDICTABLE_GAS_LIMIT = "UNPREDICTABLE_GAS_LIMIT", i.TRANSACTION_REPLACED = "TRANSACTION_REPLACED", i.ACTION_REJECTED = "ACTION_REJECTED";
})(Ut || (Ut = {}));
const te = "0123456789abcdef";
class P {
  constructor(n) {
    Object.defineProperty(this, "version", {
      enumerable: !0,
      value: n,
      writable: !1
    });
  }
  _log(n, u) {
    const d = n.toLowerCase();
    Nr[d] == null && this.throwArgumentError("invalid log level name", "logLevel", n), !(Jr > Nr[d]) && console.log.apply(console, u);
  }
  debug(...n) {
    this._log(P.levels.DEBUG, n);
  }
  info(...n) {
    this._log(P.levels.INFO, n);
  }
  warn(...n) {
    this._log(P.levels.WARNING, n);
  }
  makeError(n, u, d) {
    if (Yr)
      return this.makeError("censored error", u, {});
    u || (u = P.errors.UNKNOWN_ERROR), d || (d = {});
    const g = [];
    Object.keys(d).forEach((_) => {
      const U = d[_];
      try {
        if (U instanceof Uint8Array) {
          let C = "";
          for (let B = 0; B < U.length; B++)
            C += te[U[B] >> 4], C += te[U[B] & 15];
          g.push(_ + "=Uint8Array(0x" + C + ")");
        } else
          g.push(_ + "=" + JSON.stringify(U));
      } catch {
        g.push(_ + "=" + JSON.stringify(d[_].toString()));
      }
    }), g.push(`code=${u}`), g.push(`version=${this.version}`);
    const l = n;
    let y = "";
    switch (u) {
      case Ut.NUMERIC_FAULT: {
        y = "NUMERIC_FAULT";
        const _ = n;
        switch (_) {
          case "overflow":
          case "underflow":
          case "division-by-zero":
            y += "-" + _;
            break;
          case "negative-power":
          case "negative-width":
            y += "-unsupported";
            break;
          case "unbound-bitwise-result":
            y += "-unbound-result";
            break;
        }
        break;
      }
      case Ut.CALL_EXCEPTION:
      case Ut.INSUFFICIENT_FUNDS:
      case Ut.MISSING_NEW:
      case Ut.NONCE_EXPIRED:
      case Ut.REPLACEMENT_UNDERPRICED:
      case Ut.TRANSACTION_REPLACED:
      case Ut.UNPREDICTABLE_GAS_LIMIT:
        y = u;
        break;
    }
    y && (n += " [ See: https://links.ethers.org/v5-errors-" + y + " ]"), g.length && (n += " (" + g.join(", ") + ")");
    const T = new Error(n);
    return T.reason = l, T.code = u, Object.keys(d).forEach(function(_) {
      T[_] = d[_];
    }), T;
  }
  throwError(n, u, d) {
    throw this.makeError(n, u, d);
  }
  throwArgumentError(n, u, d) {
    return this.throwError(n, P.errors.INVALID_ARGUMENT, {
      argument: u,
      value: d
    });
  }
  assert(n, u, d, g) {
    n || this.throwError(u, d, g);
  }
  assertArgument(n, u, d, g) {
    n || this.throwArgumentError(u, d, g);
  }
  checkNormalize(n) {
    Qr && this.throwError("platform missing String.prototype.normalize", P.errors.UNSUPPORTED_OPERATION, {
      operation: "String.prototype.normalize",
      form: Qr
    });
  }
  checkSafeUint53(n, u) {
    typeof n == "number" && (u == null && (u = "value not safe"), (n < 0 || n >= 9007199254740991) && this.throwError(u, P.errors.NUMERIC_FAULT, {
      operation: "checkSafeInteger",
      fault: "out-of-safe-range",
      value: n
    }), n % 1 && this.throwError(u, P.errors.NUMERIC_FAULT, {
      operation: "checkSafeInteger",
      fault: "non-integer",
      value: n
    }));
  }
  checkArgumentCount(n, u, d) {
    d ? d = ": " + d : d = "", n < u && this.throwError("missing argument" + d, P.errors.MISSING_ARGUMENT, {
      count: n,
      expectedCount: u
    }), n > u && this.throwError("too many arguments" + d, P.errors.UNEXPECTED_ARGUMENT, {
      count: n,
      expectedCount: u
    });
  }
  checkNew(n, u) {
    (n === Object || n == null) && this.throwError("missing new", P.errors.MISSING_NEW, { name: u.name });
  }
  checkAbstract(n, u) {
    n === u ? this.throwError("cannot instantiate abstract class " + JSON.stringify(u.name) + " directly; use a sub-class", P.errors.UNSUPPORTED_OPERATION, { name: n.name, operation: "new" }) : (n === Object || n == null) && this.throwError("missing new", P.errors.MISSING_NEW, { name: u.name });
  }
  static globalLogger() {
    return Wr || (Wr = new P(Ce)), Wr;
  }
  static setCensorship(n, u) {
    if (!n && u && this.globalLogger().throwError("cannot permanently disable censorship", P.errors.UNSUPPORTED_OPERATION, {
      operation: "setCensorship"
    }), Kr) {
      if (!n)
        return;
      this.globalLogger().throwError("error censorship permanent", P.errors.UNSUPPORTED_OPERATION, {
        operation: "setCensorship"
      });
    }
    Yr = !!n, Kr = !!u;
  }
  static setLogLevel(n) {
    const u = Nr[n.toLowerCase()];
    if (u == null) {
      P.globalLogger().warn("invalid log level - " + n);
      return;
    }
    Jr = u;
  }
  static from(n) {
    return new P(n);
  }
}
P.errors = Ut;
P.levels = zr;
const De = "bytes/5.7.0", Wt = new P(De);
function me(i) {
  return !!i.toHexString;
}
function Ar(i) {
  return i.slice || (i.slice = function() {
    const n = Array.prototype.slice.call(arguments);
    return Ar(new Uint8Array(Array.prototype.slice.apply(i, n)));
  }), i;
}
function re(i) {
  return typeof i == "number" && i == i && i % 1 === 0;
}
function vr(i) {
  if (i == null)
    return !1;
  if (i.constructor === Uint8Array)
    return !0;
  if (typeof i == "string" || !re(i.length) || i.length < 0)
    return !1;
  for (let n = 0; n < i.length; n++) {
    const u = i[n];
    if (!re(u) || u < 0 || u >= 256)
      return !1;
  }
  return !0;
}
function Fe(i, n) {
  if (n || (n = {}), typeof i == "number") {
    Wt.checkSafeUint53(i, "invalid arrayify value");
    const u = [];
    for (; i; )
      u.unshift(i & 255), i = parseInt(String(i / 256));
    return u.length === 0 && u.push(0), Ar(new Uint8Array(u));
  }
  if (n.allowMissingPrefix && typeof i == "string" && i.substring(0, 2) !== "0x" && (i = "0x" + i), me(i) && (i = i.toHexString()), tr(i)) {
    let u = i.substring(2);
    u.length % 2 && (n.hexPad === "left" ? u = "0" + u : n.hexPad === "right" ? u += "0" : Wt.throwArgumentError("hex data is odd-length", "value", i));
    const d = [];
    for (let g = 0; g < u.length; g += 2)
      d.push(parseInt(u.substring(g, g + 2), 16));
    return Ar(new Uint8Array(d));
  }
  return vr(i) ? Ar(new Uint8Array(i)) : Wt.throwArgumentError("invalid arrayify value", "value", i);
}
function tr(i, n) {
  return !(typeof i != "string" || !i.match(/^0x[0-9A-Fa-f]*$/) || n && i.length !== 2 + 2 * n);
}
const Gr = "0123456789abcdef";
function pe(i, n) {
  if (n || (n = {}), typeof i == "number") {
    Wt.checkSafeUint53(i, "invalid hexlify value");
    let u = "";
    for (; i; )
      u = Gr[i & 15] + u, i = Math.floor(i / 16);
    return u.length ? (u.length % 2 && (u = "0" + u), "0x" + u) : "0x00";
  }
  if (typeof i == "bigint")
    return i = i.toString(16), i.length % 2 ? "0x0" + i : "0x" + i;
  if (n.allowMissingPrefix && typeof i == "string" && i.substring(0, 2) !== "0x" && (i = "0x" + i), me(i))
    return i.toHexString();
  if (tr(i))
    return i.length % 2 && (n.hexPad === "left" ? i = "0x0" + i.substring(2) : n.hexPad === "right" ? i += "0" : Wt.throwArgumentError("hex data is odd-length", "value", i)), i.toLowerCase();
  if (vr(i)) {
    let u = "0x";
    for (let d = 0; d < i.length; d++) {
      let g = i[d];
      u += Gr[(g & 240) >> 4] + Gr[g & 15];
    }
    return u;
  }
  return Wt.throwArgumentError("invalid hexlify value", "value", i);
}
function ee(i, n) {
  for (typeof i != "string" ? i = pe(i) : tr(i) || Wt.throwArgumentError("invalid hex string", "value", i), i.length > 2 * n + 2 && Wt.throwArgumentError("value out of range", "value", arguments[1]); i.length < 2 * n + 2; )
    i = "0x0" + i.substring(2);
  return i;
}
const ve = "bignumber/5.7.0";
var Hr = Le.BN;
const Bt = new P(ve), Vr = {}, ie = 9007199254740991;
function Be(i) {
  return i != null && (Mt.isBigNumber(i) || typeof i == "number" && i % 1 === 0 || typeof i == "string" && !!i.match(/^-?[0-9]+$/) || tr(i) || typeof i == "bigint" || vr(i));
}
let ne = !1;
class Mt {
  constructor(n, u) {
    n !== Vr && Bt.throwError("cannot call constructor directly; use BigNumber.from", P.errors.UNSUPPORTED_OPERATION, {
      operation: "new (BigNumber)"
    }), this._hex = u, this._isBigNumber = !0, Object.freeze(this);
  }
  fromTwos(n) {
    return St(I(this).fromTwos(n));
  }
  toTwos(n) {
    return St(I(this).toTwos(n));
  }
  abs() {
    return this._hex[0] === "-" ? Mt.from(this._hex.substring(1)) : this;
  }
  add(n) {
    return St(I(this).add(I(n)));
  }
  sub(n) {
    return St(I(this).sub(I(n)));
  }
  div(n) {
    return Mt.from(n).isZero() && Ot("division-by-zero", "div"), St(I(this).div(I(n)));
  }
  mul(n) {
    return St(I(this).mul(I(n)));
  }
  mod(n) {
    const u = I(n);
    return u.isNeg() && Ot("division-by-zero", "mod"), St(I(this).umod(u));
  }
  pow(n) {
    const u = I(n);
    return u.isNeg() && Ot("negative-power", "pow"), St(I(this).pow(u));
  }
  and(n) {
    const u = I(n);
    return (this.isNegative() || u.isNeg()) && Ot("unbound-bitwise-result", "and"), St(I(this).and(u));
  }
  or(n) {
    const u = I(n);
    return (this.isNegative() || u.isNeg()) && Ot("unbound-bitwise-result", "or"), St(I(this).or(u));
  }
  xor(n) {
    const u = I(n);
    return (this.isNegative() || u.isNeg()) && Ot("unbound-bitwise-result", "xor"), St(I(this).xor(u));
  }
  mask(n) {
    return (this.isNegative() || n < 0) && Ot("negative-width", "mask"), St(I(this).maskn(n));
  }
  shl(n) {
    return (this.isNegative() || n < 0) && Ot("negative-width", "shl"), St(I(this).shln(n));
  }
  shr(n) {
    return (this.isNegative() || n < 0) && Ot("negative-width", "shr"), St(I(this).shrn(n));
  }
  eq(n) {
    return I(this).eq(I(n));
  }
  lt(n) {
    return I(this).lt(I(n));
  }
  lte(n) {
    return I(this).lte(I(n));
  }
  gt(n) {
    return I(this).gt(I(n));
  }
  gte(n) {
    return I(this).gte(I(n));
  }
  isNegative() {
    return this._hex[0] === "-";
  }
  isZero() {
    return I(this).isZero();
  }
  toNumber() {
    try {
      return I(this).toNumber();
    } catch {
      Ot("overflow", "toNumber", this.toString());
    }
    return null;
  }
  toBigInt() {
    try {
      return BigInt(this.toString());
    } catch {
    }
    return Bt.throwError("this platform does not support BigInt", P.errors.UNSUPPORTED_OPERATION, {
      value: this.toString()
    });
  }
  toString() {
    return arguments.length > 0 && (arguments[0] === 10 ? ne || (ne = !0, Bt.warn("BigNumber.toString does not accept any parameters; base-10 is assumed")) : arguments[0] === 16 ? Bt.throwError("BigNumber.toString does not accept any parameters; use bigNumber.toHexString()", P.errors.UNEXPECTED_ARGUMENT, {}) : Bt.throwError("BigNumber.toString does not accept parameters", P.errors.UNEXPECTED_ARGUMENT, {})), I(this).toString(10);
  }
  toHexString() {
    return this._hex;
  }
  toJSON(n) {
    return { type: "BigNumber", hex: this.toHexString() };
  }
  static from(n) {
    if (n instanceof Mt)
      return n;
    if (typeof n == "string")
      return n.match(/^-?0x[0-9a-f]+$/i) ? new Mt(Vr, pr(n)) : n.match(/^-?[0-9]+$/) ? new Mt(Vr, pr(new Hr(n))) : Bt.throwArgumentError("invalid BigNumber string", "value", n);
    if (typeof n == "number")
      return n % 1 && Ot("underflow", "BigNumber.from", n), (n >= ie || n <= -ie) && Ot("overflow", "BigNumber.from", n), Mt.from(String(n));
    const u = n;
    if (typeof u == "bigint")
      return Mt.from(u.toString());
    if (vr(u))
      return Mt.from(pe(u));
    if (u)
      if (u.toHexString) {
        const d = u.toHexString();
        if (typeof d == "string")
          return Mt.from(d);
      } else {
        let d = u._hex;
        if (d == null && u.type === "BigNumber" && (d = u.hex), typeof d == "string" && (tr(d) || d[0] === "-" && tr(d.substring(1))))
          return Mt.from(d);
      }
    return Bt.throwArgumentError("invalid BigNumber value", "value", n);
  }
  static isBigNumber(n) {
    return !!(n && n._isBigNumber);
  }
}
function pr(i) {
  if (typeof i != "string")
    return pr(i.toString(16));
  if (i[0] === "-")
    return i = i.substring(1), i[0] === "-" && Bt.throwArgumentError("invalid hex", "value", i), i = pr(i), i === "0x00" ? i : "-" + i;
  if (i.substring(0, 2) !== "0x" && (i = "0x" + i), i === "0x")
    return "0x00";
  for (i.length % 2 && (i = "0x0" + i.substring(2)); i.length > 4 && i.substring(0, 4) === "0x00"; )
    i = "0x" + i.substring(4);
  return i;
}
function St(i) {
  return Mt.from(pr(i));
}
function I(i) {
  const n = Mt.from(i).toHexString();
  return n[0] === "-" ? new Hr("-" + n.substring(3), 16) : new Hr(n.substring(2), 16);
}
function Ot(i, n, u) {
  const d = { fault: i, operation: n };
  return u != null && (d.value = u), Bt.throwError(i, P.errors.NUMERIC_FAULT, d);
}
const At = new P(ve), dr = {}, ge = Mt.from(0), we = Mt.from(-1);
function Me(i, n, u, d) {
  const g = { fault: n, operation: u };
  return d !== void 0 && (g.value = d), At.throwError(i, P.errors.NUMERIC_FAULT, g);
}
let mr = "0";
for (; mr.length < 256; )
  mr += mr;
function Xr(i) {
  if (typeof i != "number")
    try {
      i = Mt.from(i).toNumber();
    } catch {
    }
  return typeof i == "number" && i >= 0 && i <= 256 && !(i % 1) ? "1" + mr.substring(0, i) : At.throwArgumentError("invalid decimal size", "decimals", i);
}
function jr(i, n) {
  n == null && (n = 0);
  const u = Xr(n);
  i = Mt.from(i);
  const d = i.lt(ge);
  d && (i = i.mul(we));
  let g = i.mod(u).toString();
  for (; g.length < u.length - 1; )
    g = "0" + g;
  g = g.match(/^([0-9]*[1-9]|0)(0*)/)[1];
  const l = i.div(u).toString();
  return u.length === 1 ? i = l : i = l + "." + g, d && (i = "-" + i), i;
}
function Dt(i, n) {
  n == null && (n = 0);
  const u = Xr(n);
  (typeof i != "string" || !i.match(/^-?[0-9.]+$/)) && At.throwArgumentError("invalid decimal value", "value", i);
  const d = i.substring(0, 1) === "-";
  d && (i = i.substring(1)), i === "." && At.throwArgumentError("missing value", "value", i);
  const g = i.split(".");
  g.length > 2 && At.throwArgumentError("too many decimal points", "value", i);
  let l = g[0], y = g[1];
  for (l || (l = "0"), y || (y = "0"); y[y.length - 1] === "0"; )
    y = y.substring(0, y.length - 1);
  for (y.length > u.length - 1 && Me("fractional component exceeds decimals", "underflow", "parseFixed"), y === "" && (y = "0"); y.length < u.length - 1; )
    y += "0";
  const T = Mt.from(l), _ = Mt.from(y);
  let U = T.mul(u).add(_);
  return d && (U = U.mul(we)), U;
}
class Qt {
  constructor(n, u, d, g) {
    n !== dr && At.throwError("cannot use FixedFormat constructor; use FixedFormat.from", P.errors.UNSUPPORTED_OPERATION, {
      operation: "new FixedFormat"
    }), this.signed = u, this.width = d, this.decimals = g, this.name = (u ? "" : "u") + "fixed" + String(d) + "x" + String(g), this._multiplier = Xr(g), Object.freeze(this);
  }
  static from(n) {
    if (n instanceof Qt)
      return n;
    typeof n == "number" && (n = `fixed128x${n}`);
    let u = !0, d = 128, g = 18;
    if (typeof n == "string") {
      if (n !== "fixed")
        if (n === "ufixed")
          u = !1;
        else {
          const l = n.match(/^(u?)fixed([0-9]+)x([0-9]+)$/);
          l || At.throwArgumentError("invalid fixed format", "format", n), u = l[1] !== "u", d = parseInt(l[2]), g = parseInt(l[3]);
        }
    } else if (n) {
      const l = (y, T, _) => n[y] == null ? _ : (typeof n[y] !== T && At.throwArgumentError("invalid fixed format (" + y + " not " + T + ")", "format." + y, n[y]), n[y]);
      u = l("signed", "boolean", u), d = l("width", "number", d), g = l("decimals", "number", g);
    }
    return d % 8 && At.throwArgumentError("invalid fixed format width (not byte aligned)", "format.width", d), g > 80 && At.throwArgumentError("invalid fixed format (decimals too large)", "format.decimals", g), new Qt(dr, u, d, g);
  }
}
class Rt {
  constructor(n, u, d, g) {
    n !== dr && At.throwError("cannot use FixedNumber constructor; use FixedNumber.from", P.errors.UNSUPPORTED_OPERATION, {
      operation: "new FixedFormat"
    }), this.format = g, this._hex = u, this._value = d, this._isFixedNumber = !0, Object.freeze(this);
  }
  _checkFormat(n) {
    this.format.name !== n.format.name && At.throwArgumentError("incompatible format; use fixedNumber.toFormat", "other", n);
  }
  addUnsafe(n) {
    this._checkFormat(n);
    const u = Dt(this._value, this.format.decimals), d = Dt(n._value, n.format.decimals);
    return Rt.fromValue(u.add(d), this.format.decimals, this.format);
  }
  subUnsafe(n) {
    this._checkFormat(n);
    const u = Dt(this._value, this.format.decimals), d = Dt(n._value, n.format.decimals);
    return Rt.fromValue(u.sub(d), this.format.decimals, this.format);
  }
  mulUnsafe(n) {
    this._checkFormat(n);
    const u = Dt(this._value, this.format.decimals), d = Dt(n._value, n.format.decimals);
    return Rt.fromValue(u.mul(d).div(this.format._multiplier), this.format.decimals, this.format);
  }
  divUnsafe(n) {
    this._checkFormat(n);
    const u = Dt(this._value, this.format.decimals), d = Dt(n._value, n.format.decimals);
    return Rt.fromValue(u.mul(this.format._multiplier).div(d), this.format.decimals, this.format);
  }
  floor() {
    const n = this.toString().split(".");
    n.length === 1 && n.push("0");
    let u = Rt.from(n[0], this.format);
    const d = !n[1].match(/^(0*)$/);
    return this.isNegative() && d && (u = u.subUnsafe(oe.toFormat(u.format))), u;
  }
  ceiling() {
    const n = this.toString().split(".");
    n.length === 1 && n.push("0");
    let u = Rt.from(n[0], this.format);
    const d = !n[1].match(/^(0*)$/);
    return !this.isNegative() && d && (u = u.addUnsafe(oe.toFormat(u.format))), u;
  }
  round(n) {
    n == null && (n = 0);
    const u = this.toString().split(".");
    if (u.length === 1 && u.push("0"), (n < 0 || n > 80 || n % 1) && At.throwArgumentError("invalid decimal count", "decimals", n), u[1].length <= n)
      return this;
    const d = Rt.from("1" + mr.substring(0, n), this.format), g = $e.toFormat(this.format);
    return this.mulUnsafe(d).addUnsafe(g).floor().divUnsafe(d);
  }
  isZero() {
    return this._value === "0.0" || this._value === "0";
  }
  isNegative() {
    return this._value[0] === "-";
  }
  toString() {
    return this._value;
  }
  toHexString(n) {
    if (n == null)
      return this._hex;
    n % 8 && At.throwArgumentError("invalid byte width", "width", n);
    const u = Mt.from(this._hex).fromTwos(this.format.width).toTwos(n).toHexString();
    return ee(u, n / 8);
  }
  toUnsafeFloat() {
    return parseFloat(this.toString());
  }
  toFormat(n) {
    return Rt.fromString(this._value, n);
  }
  static fromValue(n, u, d) {
    return d == null && u != null && !Be(u) && (d = u, u = null), u == null && (u = 0), d == null && (d = "fixed"), Rt.fromString(jr(n, u), Qt.from(d));
  }
  static fromString(n, u) {
    u == null && (u = "fixed");
    const d = Qt.from(u), g = Dt(n, d.decimals);
    !d.signed && g.lt(ge) && Me("unsigned value cannot be negative", "overflow", "value", n);
    let l = null;
    d.signed ? l = g.toTwos(d.width).toHexString() : (l = g.toHexString(), l = ee(l, d.width / 8));
    const y = jr(g, d.decimals);
    return new Rt(dr, l, y, d);
  }
  static fromBytes(n, u) {
    u == null && (u = "fixed");
    const d = Qt.from(u);
    if (Fe(n).length > d.width / 8)
      throw new Error("overflow");
    let g = Mt.from(n);
    d.signed && (g = g.fromTwos(d.width));
    const l = g.toTwos((d.signed ? 0 : 1) + d.width).toHexString(), y = jr(g, d.decimals);
    return new Rt(dr, l, y, d);
  }
  static from(n, u) {
    if (typeof n == "string")
      return Rt.fromString(n, u);
    if (vr(n))
      return Rt.fromBytes(n, u);
    try {
      return Rt.fromValue(n, 0, u);
    } catch (d) {
      if (d.code !== P.errors.INVALID_ARGUMENT)
        throw d;
    }
    return At.throwArgumentError("invalid FixedNumber value", "value", n);
  }
  static isFixedNumber(n) {
    return !!(n && n._isFixedNumber);
  }
}
const oe = Rt.from(1), $e = Rt.from("0.5"), qe = "units/5.2.0", We = new P(qe), Ge = [
  "wei",
  "kwei",
  "mwei",
  "gwei",
  "szabo",
  "finney",
  "ether"
];
function Ve(i, n) {
  if (typeof i != "string" && We.throwArgumentError("value must be a string", "value", i), typeof n == "string") {
    const u = Ge.indexOf(n);
    u !== -1 && (n = 3 * u);
  }
  return Dt(i, n != null ? n : 18);
}
function je(i) {
  return Ve(i, 18);
}
var qt = /* @__PURE__ */ ((i) => (i.STAKE = "stake", i.UNSTAKE = "unstake", i.WITHDRAW = "withdraw", i.ALLOWANCE = "allowance", i.GET_ALLOWANCE = "getAllowance", i.GET_UNSTAKES = "getUnstakes", i.LIMITS = "limits", i))(qt || {});
const ze = {
  chainId: !0,
  data: !0,
  gasLimit: !0,
  gasPrice: !0,
  nonce: !0,
  to: !0,
  value: !0,
  type: !0,
  accessList: !0,
  maxFeePerGas: !0,
  maxPriorityFeePerGas: !0
}, He = {
  [Pt.SD]: "/sd",
  [Pt.ETHX]: "/ethx",
  [Pt.BNBX]: "/bnbx",
  [Pt.MATICX]: "/maticx",
  [Pt.SFTMX]: "/sftmx"
}, Ze = {
  [Pt.SD]: "/sd",
  [Pt.ETHX]: "/eth",
  [Pt.BNBX]: "/bnb",
  [Pt.MATICX]: "/Polygon",
  [Pt.SFTMX]: "/fantom"
};
var gr = /* @__PURE__ */ ((i) => (i.TVL = "tvl", i.APY = "apy", i.EXCHANGE_RATE = "exchangeRate", i.SAFE_MODE = "safeMode", i))(gr || {}), ye = /* @__PURE__ */ ((i) => (i.MAINNET = "MAINNET", i.TESTNET = "TESTNET", i))(ye || {});
const Xe = () => process.env.NEXT_PUBLIC_NETWORK !== ye.MAINNET, Ke = {
  isTestnet: Xe
};
var Zr = /* @__PURE__ */ ((i) => (i.MAINNET = "https://stage-yeilds.staderlabs.click", i.TESTNET = "https://stage-yeilds.staderlabs.click", i))(Zr || {});
const Ye = process.env.NEXT_PUBLIC_TESTNET_API_URL, Je = process.env.NEXT_PUBLIC_MAINNET_API_URL, Qe = () => Ke.isTestnet() ? Ye || Zr.TESTNET : Je || Zr.MAINNET, ti = ce.create({
  baseURL: Qe()
}), xe = ce.create({
  baseURL: "https://universe.staderlabs.com"
}), se = async ({ action: i, token: n, chainId: u, ...d }) => {
  const g = He[n];
  g || console.error("couldn't find api subpath for the token :", n);
  const l = d.input ? d.input : {};
  return (await ti.post(`${g}/${i}`, {
    ...l,
    chainId: u
  })).data;
}, Tr = async ({ token: i, query: n }) => {
  const u = Ze[i];
  return u || console.error("couldn't find api subpath for the token :", i), (await xe.get(`${u}/${n}`)).data;
}, ri = async () => (await xe.get("/tvl")).data, ei = (i) => {
  var l;
  console.log("txString", i);
  const n = Ae.fromSerializedTx(Buffer.from(i, "hex"));
  console.log("tx", n);
  const u = (l = n.to) == null ? void 0 : l.buf.toString("hex");
  console.log("toAddress", u);
  const d = { ...n, to: u };
  return Object.keys(d).forEach((y) => {
    y in ze || delete d[y];
  }), console.log("txRequest", d), d;
};
var Ee = { exports: {} }, lr = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var fe;
function ii() {
  if (fe)
    return lr;
  fe = 1;
  var i = le, n = Symbol.for("react.element"), u = Symbol.for("react.fragment"), d = Object.prototype.hasOwnProperty, g = i.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, l = { key: !0, ref: !0, __self: !0, __source: !0 };
  function y(T, _, U) {
    var C, B = {}, yt = null, L = null;
    U !== void 0 && (yt = "" + U), _.key !== void 0 && (yt = "" + _.key), _.ref !== void 0 && (L = _.ref);
    for (C in _)
      d.call(_, C) && !l.hasOwnProperty(C) && (B[C] = _[C]);
    if (T && T.defaultProps)
      for (C in _ = T.defaultProps, _)
        B[C] === void 0 && (B[C] = _[C]);
    return { $$typeof: n, type: T, key: yt, ref: L, props: B, _owner: g.current };
  }
  return lr.Fragment = u, lr.jsx = y, lr.jsxs = y, lr;
}
var cr = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ae;
function ni() {
  return ae || (ae = 1, process.env.NODE_ENV !== "production" && function() {
    var i = le, n = Symbol.for("react.element"), u = Symbol.for("react.portal"), d = Symbol.for("react.fragment"), g = Symbol.for("react.strict_mode"), l = Symbol.for("react.profiler"), y = Symbol.for("react.provider"), T = Symbol.for("react.context"), _ = Symbol.for("react.forward_ref"), U = Symbol.for("react.suspense"), C = Symbol.for("react.suspense_list"), B = Symbol.for("react.memo"), yt = Symbol.for("react.lazy"), L = Symbol.for("react.offscreen"), Lt = Symbol.iterator, Vt = "@@iterator";
    function er(h) {
      if (h === null || typeof h != "object")
        return null;
      var w = Lt && h[Lt] || h[Vt];
      return typeof w == "function" ? w : null;
    }
    var Ft = i.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function bt(h) {
      {
        for (var w = arguments.length, M = new Array(w > 1 ? w - 1 : 0), x = 1; x < w; x++)
          M[x - 1] = arguments[x];
        wr("error", h, M);
      }
    }
    function wr(h, w, M) {
      {
        var x = Ft.ReactDebugCurrentFrame, O = x.getStackAddendum();
        O !== "" && (w += "%s", M = M.concat([O]));
        var N = M.map(function(E) {
          return String(E);
        });
        N.unshift("Warning: " + w), Function.prototype.apply.call(console[h], console, N);
      }
    }
    var Mr = !1, ir = !1, Tt = !1, Zt = !1, yr = !1, nr;
    nr = Symbol.for("react.module.reference");
    function or(h) {
      return !!(typeof h == "string" || typeof h == "function" || h === d || h === l || yr || h === g || h === U || h === C || Zt || h === L || Mr || ir || Tt || typeof h == "object" && h !== null && (h.$$typeof === yt || h.$$typeof === B || h.$$typeof === y || h.$$typeof === T || h.$$typeof === _ || h.$$typeof === nr || h.getModuleId !== void 0));
    }
    function z(h, w, M) {
      var x = h.displayName;
      if (x)
        return x;
      var O = w.displayName || w.name || "";
      return O !== "" ? M + "(" + O + ")" : M;
    }
    function Ct(h) {
      return h.displayName || "Context";
    }
    function m(h) {
      if (h == null)
        return null;
      if (typeof h.tag == "number" && bt("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof h == "function")
        return h.displayName || h.name || null;
      if (typeof h == "string")
        return h;
      switch (h) {
        case d:
          return "Fragment";
        case u:
          return "Portal";
        case l:
          return "Profiler";
        case g:
          return "StrictMode";
        case U:
          return "Suspense";
        case C:
          return "SuspenseList";
      }
      if (typeof h == "object")
        switch (h.$$typeof) {
          case T:
            var w = h;
            return Ct(w) + ".Consumer";
          case y:
            var M = h;
            return Ct(M._context) + ".Provider";
          case _:
            return z(h, h.render, "ForwardRef");
          case B:
            var x = h.displayName || null;
            return x !== null ? x : m(h.type) || "Memo";
          case yt: {
            var O = h, N = O._payload, E = O._init;
            try {
              return m(E(N));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var t = Object.assign, e = 0, o, f, c, p, v, s, r;
    function a() {
    }
    a.__reactDisabledLog = !0;
    function A() {
      {
        if (e === 0) {
          o = console.log, f = console.info, c = console.warn, p = console.error, v = console.group, s = console.groupCollapsed, r = console.groupEnd;
          var h = {
            configurable: !0,
            enumerable: !0,
            value: a,
            writable: !0
          };
          Object.defineProperties(console, {
            info: h,
            log: h,
            warn: h,
            error: h,
            group: h,
            groupCollapsed: h,
            groupEnd: h
          });
        }
        e++;
      }
    }
    function b() {
      {
        if (e--, e === 0) {
          var h = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: t({}, h, {
              value: o
            }),
            info: t({}, h, {
              value: f
            }),
            warn: t({}, h, {
              value: c
            }),
            error: t({}, h, {
              value: p
            }),
            group: t({}, h, {
              value: v
            }),
            groupCollapsed: t({}, h, {
              value: s
            }),
            groupEnd: t({}, h, {
              value: r
            })
          });
        }
        e < 0 && bt("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var R = Ft.ReactCurrentDispatcher, xt;
    function k(h, w, M) {
      {
        if (xt === void 0)
          try {
            throw Error();
          } catch (O) {
            var x = O.stack.trim().match(/\n( *(at )?)/);
            xt = x && x[1] || "";
          }
        return `
` + xt + h;
      }
    }
    var D = !1, jt;
    {
      var rt = typeof WeakMap == "function" ? WeakMap : Map;
      jt = new rt();
    }
    function H(h, w) {
      if (!h || D)
        return "";
      {
        var M = jt.get(h);
        if (M !== void 0)
          return M;
      }
      var x;
      D = !0;
      var O = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var N;
      N = R.current, R.current = null, A();
      try {
        if (w) {
          var E = function() {
            throw Error();
          };
          if (Object.defineProperty(E.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(E, []);
            } catch (It) {
              x = It;
            }
            Reflect.construct(h, [], E);
          } else {
            try {
              E.call();
            } catch (It) {
              x = It;
            }
            h.call(E.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (It) {
            x = It;
          }
          h();
        }
      } catch (It) {
        if (It && x && typeof It.stack == "string") {
          for (var S = It.stack.split(`
`), _t = x.stack.split(`
`), W = S.length - 1, j = _t.length - 1; W >= 1 && j >= 0 && S[W] !== _t[j]; )
            j--;
          for (; W >= 1 && j >= 0; W--, j--)
            if (S[W] !== _t[j]) {
              if (W !== 1 || j !== 1)
                do
                  if (W--, j--, j < 0 || S[W] !== _t[j]) {
                    var Nt = `
` + S[W].replace(" at new ", " at ");
                    return h.displayName && Nt.includes("<anonymous>") && (Nt = Nt.replace("<anonymous>", h.displayName)), typeof h == "function" && jt.set(h, Nt), Nt;
                  }
                while (W >= 1 && j >= 0);
              break;
            }
        }
      } finally {
        D = !1, R.current = N, b(), Error.prepareStackTrace = O;
      }
      var kt = h ? h.displayName || h.name : "", Jt = kt ? k(kt) : "";
      return typeof h == "function" && jt.set(h, Jt), Jt;
    }
    function xr(h, w, M) {
      return H(h, !1);
    }
    function et(h) {
      var w = h.prototype;
      return !!(w && w.isReactComponent);
    }
    function q(h, w, M) {
      if (h == null)
        return "";
      if (typeof h == "function")
        return H(h, et(h));
      if (typeof h == "string")
        return k(h);
      switch (h) {
        case U:
          return k("Suspense");
        case C:
          return k("SuspenseList");
      }
      if (typeof h == "object")
        switch (h.$$typeof) {
          case _:
            return xr(h.render);
          case B:
            return q(h.type, w, M);
          case yt: {
            var x = h, O = x._payload, N = x._init;
            try {
              return q(N(O), w, M);
            } catch {
            }
          }
        }
      return "";
    }
    var zt = Object.prototype.hasOwnProperty, Z = {}, X = Ft.ReactDebugCurrentFrame;
    function Ht(h) {
      if (h) {
        var w = h._owner, M = q(h.type, h._source, w ? w.type : null);
        X.setExtraStackFrame(M);
      } else
        X.setExtraStackFrame(null);
    }
    function it(h, w, M, x, O) {
      {
        var N = Function.call.bind(zt);
        for (var E in h)
          if (N(h, E)) {
            var S = void 0;
            try {
              if (typeof h[E] != "function") {
                var _t = Error((x || "React class") + ": " + M + " type `" + E + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof h[E] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw _t.name = "Invariant Violation", _t;
              }
              S = h[E](w, E, x, M, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (W) {
              S = W;
            }
            S && !(S instanceof Error) && (Ht(O), bt("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", x || "React class", M, E, typeof S), Ht(null)), S instanceof Error && !(S.message in Z) && (Z[S.message] = !0, Ht(O), bt("Failed %s type: %s", M, S.message), Ht(null));
          }
      }
    }
    var nt = Array.isArray;
    function Xt(h) {
      return nt(h);
    }
    function ot(h) {
      {
        var w = typeof Symbol == "function" && Symbol.toStringTag, M = w && h[Symbol.toStringTag] || h.constructor.name || "Object";
        return M;
      }
    }
    function st(h) {
      try {
        return sr(h), !1;
      } catch {
        return !0;
      }
    }
    function sr(h) {
      return "" + h;
    }
    function K(h) {
      if (st(h))
        return bt("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", ot(h)), sr(h);
    }
    var $ = Ft.ReactCurrentOwner, Er = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Y, J, Kt;
    Kt = {};
    function ft(h) {
      if (zt.call(h, "ref")) {
        var w = Object.getOwnPropertyDescriptor(h, "ref").get;
        if (w && w.isReactWarning)
          return !1;
      }
      return h.ref !== void 0;
    }
    function at(h) {
      if (zt.call(h, "key")) {
        var w = Object.getOwnPropertyDescriptor(h, "key").get;
        if (w && w.isReactWarning)
          return !1;
      }
      return h.key !== void 0;
    }
    function _r(h, w) {
      if (typeof h.ref == "string" && $.current && w && $.current.stateNode !== w) {
        var M = m($.current.type);
        Kt[M] || (bt('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', m($.current.type), h.ref), Kt[M] = !0);
      }
    }
    function ht(h, w) {
      {
        var M = function() {
          Y || (Y = !0, bt("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", w));
        };
        M.isReactWarning = !0, Object.defineProperty(h, "key", {
          get: M,
          configurable: !0
        });
      }
    }
    function ut(h, w) {
      {
        var M = function() {
          J || (J = !0, bt("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", w));
        };
        M.isReactWarning = !0, Object.defineProperty(h, "ref", {
          get: M,
          configurable: !0
        });
      }
    }
    var br = function(h, w, M, x, O, N, E) {
      var S = {
        $$typeof: n,
        type: h,
        key: w,
        ref: M,
        props: E,
        _owner: N
      };
      return S._store = {}, Object.defineProperty(S._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(S, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: x
      }), Object.defineProperty(S, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: O
      }), Object.freeze && (Object.freeze(S.props), Object.freeze(S)), S;
    };
    function lt(h, w, M, x, O) {
      {
        var N, E = {}, S = null, _t = null;
        M !== void 0 && (K(M), S = "" + M), at(w) && (K(w.key), S = "" + w.key), ft(w) && (_t = w.ref, _r(w, O));
        for (N in w)
          zt.call(w, N) && !Er.hasOwnProperty(N) && (E[N] = w[N]);
        if (h && h.defaultProps) {
          var W = h.defaultProps;
          for (N in W)
            E[N] === void 0 && (E[N] = W[N]);
        }
        if (S || _t) {
          var j = typeof h == "function" ? h.displayName || h.name || "Unknown" : h;
          S && ht(E, j), _t && ut(E, j);
        }
        return br(h, S, _t, O, x, $.current, E);
      }
    }
    var G = Ft.ReactCurrentOwner, fr = Ft.ReactDebugCurrentFrame;
    function F(h) {
      if (h) {
        var w = h._owner, M = q(h.type, h._source, w ? w.type : null);
        fr.setExtraStackFrame(M);
      } else
        fr.setExtraStackFrame(null);
    }
    var V;
    V = !1;
    function Yt(h) {
      return typeof h == "object" && h !== null && h.$$typeof === n;
    }
    function Q() {
      {
        if (G.current) {
          var h = m(G.current.type);
          if (h)
            return `

Check the render method of \`` + h + "`.";
        }
        return "";
      }
    }
    function ct(h) {
      {
        if (h !== void 0) {
          var w = h.fileName.replace(/^.*[\\\/]/, ""), M = h.lineNumber;
          return `

Check your code at ` + w + ":" + M + ".";
        }
        return "";
      }
    }
    var ar = {};
    function dt(h) {
      {
        var w = Q();
        if (!w) {
          var M = typeof h == "string" ? h : h.displayName || h.name;
          M && (w = `

Check the top-level render call using <` + M + ">.");
        }
        return w;
      }
    }
    function tt(h, w) {
      {
        if (!h._store || h._store.validated || h.key != null)
          return;
        h._store.validated = !0;
        var M = dt(w);
        if (ar[M])
          return;
        ar[M] = !0;
        var x = "";
        h && h._owner && h._owner !== G.current && (x = " It was passed a child from " + m(h._owner.type) + "."), F(h), bt('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', M, x), F(null);
      }
    }
    function hr(h, w) {
      {
        if (typeof h != "object")
          return;
        if (Xt(h))
          for (var M = 0; M < h.length; M++) {
            var x = h[M];
            Yt(x) && tt(x, w);
          }
        else if (Yt(h))
          h._store && (h._store.validated = !0);
        else if (h) {
          var O = er(h);
          if (typeof O == "function" && O !== h.entries)
            for (var N = O.call(h), E; !(E = N.next()).done; )
              Yt(E.value) && tt(E.value, w);
        }
      }
    }
    function mt(h) {
      {
        var w = h.type;
        if (w == null || typeof w == "string")
          return;
        var M;
        if (typeof w == "function")
          M = w.propTypes;
        else if (typeof w == "object" && (w.$$typeof === _ || w.$$typeof === B))
          M = w.propTypes;
        else
          return;
        if (M) {
          var x = m(w);
          it(M, h.props, "prop", x, h);
        } else if (w.PropTypes !== void 0 && !V) {
          V = !0;
          var O = m(w);
          bt("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", O || "Unknown");
        }
        typeof w.getDefaultProps == "function" && !w.getDefaultProps.isReactClassApproved && bt("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function pt(h) {
      {
        for (var w = Object.keys(h.props), M = 0; M < w.length; M++) {
          var x = w[M];
          if (x !== "children" && x !== "key") {
            F(h), bt("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", x), F(null);
            break;
          }
        }
        h.ref !== null && (F(h), bt("Invalid attribute `ref` supplied to `React.Fragment`."), F(null));
      }
    }
    function ur(h, w, M, x, O, N) {
      {
        var E = or(h);
        if (!E) {
          var S = "";
          (h === void 0 || typeof h == "object" && h !== null && Object.keys(h).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var _t = ct(O);
          _t ? S += _t : S += Q();
          var W;
          h === null ? W = "null" : Xt(h) ? W = "array" : h !== void 0 && h.$$typeof === n ? (W = "<" + (m(h.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : W = typeof h, bt("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", W, S);
        }
        var j = lt(h, w, M, O, N);
        if (j == null)
          return j;
        if (E) {
          var Nt = w.children;
          if (Nt !== void 0)
            if (x)
              if (Xt(Nt)) {
                for (var kt = 0; kt < Nt.length; kt++)
                  hr(Nt[kt], h);
                Object.freeze && Object.freeze(Nt);
              } else
                bt("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              hr(Nt, h);
        }
        return h === d ? pt(j) : mt(j), j;
      }
    }
    function vt(h, w, M) {
      return ur(h, w, M, !0);
    }
    function gt(h, w, M) {
      return ur(h, w, M, !1);
    }
    var Rr = gt, wt = vt;
    cr.Fragment = d, cr.jsx = Rr, cr.jsxs = wt;
  }()), cr;
}
(function(i) {
  process.env.NODE_ENV === "production" ? i.exports = ii() : i.exports = ni();
})(Ee);
const oi = Ee.exports.jsx, _e = be({}), wi = ({
  token: i,
  chainId: n,
  children: u
}) => {
  const d = Et(async (L) => {
    const Lt = await se({
      ...L,
      chainId: n
    });
    return ei(Lt);
  }, [n]), g = Et(async (L) => await se({
    ...L,
    chainId: n
  }), [n]), l = Et((L) => d({
    action: qt.STAKE,
    token: i,
    input: L
  }), [i, d]), y = Et((L) => d({
    action: qt.UNSTAKE,
    token: i,
    input: L
  }), [i, d]), T = Et((L) => d({
    action: qt.WITHDRAW,
    token: i,
    input: L
  }), [i, d]), _ = Et((L) => d({
    action: qt.ALLOWANCE,
    token: i,
    input: L
  }), [i, d]), U = Et((L) => g({
    action: qt.GET_ALLOWANCE,
    token: i,
    input: L
  }), [i, g]), C = Et((L) => g({
    action: qt.GET_UNSTAKES,
    token: i,
    input: L
  }), [i, g]), B = Et(() => g({
    action: qt.LIMITS,
    token: i
  }), [i, g]), yt = {
    token: i,
    stakeApi: l,
    unstakeApi: y,
    withdrawApi: T,
    allowanceApi: U,
    approveApi: _,
    unstakesApi: C,
    minMaxLimitApi: B
  };
  return /* @__PURE__ */ oi(_e.Provider, {
    value: yt,
    children: u
  });
}, $t = () => ({
  ...Re(_e)
}), Mi = () => {
  const {
    stakeApi: i
  } = $t();
  return {
    stake: Et(async (u, d, g) => {
      if (!d || !u) {
        console.error("wallet address missing in the params.");
        return;
      }
      if (!g) {
        console.error("input missing in the param.");
        return;
      }
      const y = await i({
        from: u,
        amount: g
      });
      if (!!y)
        return y.value = je(g), d.sendTransaction(y);
    }, [i])
  };
}, yi = () => {
  const {
    unstakeApi: i
  } = $t();
  return {
    unstake: Et(async (u, d, g) => {
      if (!d || !u) {
        console.error("wallet address missing in the params.");
        return;
      }
      const y = await i({
        from: u,
        amount: g
      });
      if (!!y)
        return d.sendTransaction(y);
    }, [i])
  };
}, xi = () => {
  const {
    withdrawApi: i,
    unstakesApi: n
  } = $t(), u = Et(async (g) => {
    if (!g) {
      console.error("wallet address missing in the params.");
      return;
    }
    return await n({
      from: g
    });
  }, [n]);
  return {
    withdraw: Et(async (g, l, y) => {
      if (!l || !g) {
        console.error("wallet address missing in the params.");
        return;
      }
      const _ = await i({
        from: g,
        index: y
      });
      if (!!_)
        return l.sendTransaction(_);
    }, [i]),
    fetchWithdrawals: u
  };
}, Ei = () => {
  const {
    allowanceApi: i,
    approveApi: n
  } = $t(), u = Et(async (g, l) => {
    if (!g) {
      console.error("No wallet detected, check wallet connection.");
      return;
    }
    if (!l) {
      console.error("tokenType missing in the param.");
      return;
    }
    return await i({
      from: g,
      tokenType: l
    });
  }, [i]);
  return {
    approve: Et(async (g, l, y, T) => {
      if (!l || !g) {
        console.error("No wallet detected, check wallet connection.");
        return;
      }
      if (!y) {
        console.error("input missing in the param.");
        return;
      }
      if (!T) {
        console.error("tokenType missing in the param.");
        return;
      }
      const U = await n({
        from: g,
        amount: y,
        tokenType: T
      });
      if (!!U)
        return l.sendTransaction(U);
    }, [n]),
    fetchAllowance: u
  };
}, _i = () => {
  const {
    minMaxLimitApi: i
  } = $t();
  return {
    fetchMinMaxLimit: Et(async () => await i(), [i])
  };
};
function he(i) {
  for (var n = [], u = 1; u < arguments.length; u++)
    n[u - 1] = arguments[u];
  i && i.addEventListener && i.addEventListener.apply(i, n);
}
function ue(i) {
  for (var n = [], u = 1; u < arguments.length; u++)
    n[u - 1] = arguments[u];
  i && i.removeEventListener && i.removeEventListener.apply(i, n);
}
function si(i, n, u, d) {
  var g, l = !1, y = 0;
  function T() {
    g && clearTimeout(g);
  }
  function _() {
    T(), l = !0;
  }
  typeof n != "boolean" && (d = u, u = n, n = void 0);
  function U() {
    for (var C = arguments.length, B = new Array(C), yt = 0; yt < C; yt++)
      B[yt] = arguments[yt];
    var L = this, Lt = Date.now() - y;
    if (l)
      return;
    function Vt() {
      y = Date.now(), u.apply(L, B);
    }
    function er() {
      g = void 0;
    }
    d && !g && Vt(), T(), d === void 0 && Lt > i ? Vt() : n !== !0 && (g = setTimeout(d ? er : Vt, d === void 0 ? i - Lt : i));
  }
  return U.cancel = _, U;
}
var fi = ["mousemove", "mousedown", "resize", "keydown", "touchstart", "wheel"], ai = 6e4, hi = function(i, n, u) {
  i === void 0 && (i = ai), n === void 0 && (n = !1), u === void 0 && (u = fi);
  var d = rr(n), g = d[0], l = d[1];
  return Gt(function() {
    for (var y = !0, T, _ = g, U = function(L) {
      y && (_ = L, l(L));
    }, C = si(50, function() {
      _ && U(!1), clearTimeout(T), T = setTimeout(function() {
        return U(!0);
      }, i);
    }), B = function() {
      document.hidden || C();
    }, yt = 0; yt < u.length; yt++)
      he(window, u[yt], C);
    return he(document, "visibilitychange", B), T = setTimeout(function() {
      return U(!0);
    }, i), function() {
      y = !1;
      for (var L = 0; L < u.length; L++)
        ue(window, u[L], C);
      ue(document, "visibilitychange", B);
    };
  }, [i, u]), g;
};
const Sr = hi;
var ui = function(i, n) {
  var u = Ne(function() {
  });
  Gt(function() {
    u.current = i;
  }), Gt(function() {
    if (n !== null) {
      var d = setInterval(function() {
        return u.current();
      }, n || 0);
      return function() {
        return clearInterval(d);
      };
    }
  }, [n]);
};
const Ir = ui, li = 1e4, bi = (i, n = !1) => {
  const u = Sr(15e4), [d, g] = rr({
    tvl: void 0,
    isLoading: !0
  }), l = Et(async () => {
    const y = await ri();
    g({
      tvl: y,
      isLoading: !1
    });
  }, []);
  return Gt(() => {
    l();
  }, [l]), Ir(() => {
    !u && !n && l();
  }, i || li), d;
}, ci = 1e4, Ri = ({
  enabled: i = !0,
  delay: n,
  disablePolling: u
}) => {
  const d = Sr(15e4), {
    token: g
  } = $t(), [l, y] = rr({
    tvl: void 0,
    isLoading: !0
  }), T = Et(async () => {
    const _ = await Tr({
      token: g,
      query: gr.TVL
    });
    y({
      tvl: _,
      isLoading: !1
    });
  }, [g]);
  return Gt(() => {
    i && T();
  }, [T, i]), Ir(() => {
    i && !d && !u && T();
  }, n || ci), l;
}, di = 1e4, Ni = ({
  enabled: i = !0,
  delay: n,
  disablePolling: u
}) => {
  const d = Sr(15e4), {
    token: g
  } = $t(), [l, y] = rr({
    apy: void 0,
    isLoading: !0
  }), T = Et(async () => {
    const _ = await Tr({
      token: g,
      query: gr.APY
    });
    y({
      apy: _.value,
      isLoading: !1
    });
  }, [g]);
  return Gt(() => {
    i && T();
  }, [T, i]), Ir(() => {
    i && !d && !u && T();
  }, n || di), l;
}, mi = 1e4, Ai = ({
  enabled: i = !0,
  delay: n,
  disablePolling: u
}) => {
  const d = Sr(15e4), {
    token: g
  } = $t(), [l, y] = rr({
    exchangeRate: void 0,
    isLoading: !0
  }), T = Et(async () => {
    const _ = await Tr({
      token: g,
      query: gr.EXCHANGE_RATE
    });
    y({
      exchangeRate: _.value,
      isLoading: !1
    });
  }, [g]);
  return Gt(() => {
    i && T();
  }, [T, i]), Ir(() => {
    i && !d && !u && T();
  }, n || mi), l;
}, Ti = () => {
  const {
    token: i
  } = $t(), [n, u] = rr({
    safeMode: !1,
    isLoading: !0
  });
  return Gt(() => {
    if (i !== Pt.ETHX)
      return;
    (async () => {
      const g = await Tr({
        token: i,
        query: gr.SAFE_MODE
      });
      u({
        safeMode: g.value,
        isLoading: !1
      });
    })();
  }, [i]), n;
};
export {
  wi as AppProvider,
  Pt as TOKEN,
  Te as TOKENTYPE,
  Ni as useAPY,
  Ei as useAllowance,
  Ai as useExchangeRate,
  _i as useLimits,
  Ti as useSafeMode,
  bi as useStaderTVL,
  Mi as useStake,
  Ri as useTVL,
  yi as useUnstake,
  xi as useWithdraw
};
